export default {
	demo_account:{
        footerpoint1:`Fxview is the trading name of the Fxview group of companies which consists of:`,
        footerpoint2:`- Parent company, Finvasia Securities Private Ltd, regulated by the Securities and Exchange Board of India (Licence No INZ000176037)`,
        footerpoint3:`- Charlgate Ltd, regulated by the Cyprus Securities and Exchange Commission (Licence No 367/18)`,
        footerpoint4:`- Charlgate SVG LLC (Reg. No. 1112 LLC 2021) with registered address at First Floor, First St Vincent Bank Ltd Building, James Street, Kingstown, Saint Vincent and the Grenadines.`,
        footerpoint5:`- Nevea Services Ltd (Reg. No. 422664) with registered address at 319, 28th October Street, Kanika Business Center, Office 201B, Limassol 3105, Cyprus.`,
        footerpoint6:`The merchant company is Nevea Services Ltd with registered address at 319, 28th October Street, Kanika Business Center, Office 201B, Limassol 3105, Cyprus. The merchant company provides content, administrative services, payment processing and safekeeping services.`,
        footerpoint7:`Clients must be at least 18 years old to use the services of Fxview.`,
        footerpoint8:`Trading complex instruments on margin carries a high level of risk and may not be suitable for all investors. Before deciding to trade, you should carefully consider your trading objectives, level of experience and risk appetite. It is possible for you to sustain losses that exceed your invested capital, and therefore you should not deposit money that you cannot afford to lose. Please ensure you fully understand the risks and take appropriate care to manage them.`,
        footerpoint9:`This site contains links to websites controlled or offered by third parties. Fxview has not reviewed and hereby disclaims responsibility for any information or materials posted at any of the sites linked to this site. By creating a link to a thirdparty website, Fxview does not endorse or recommend any products or services offered on that website. The information contained on this site is intended for informational purposes only. Therefore, it should not be regarded as an offer or solicitation to any person in any jurisdiction in which such an offer or solicitation is not authorized or to any person to whom it would be unlawful to make such an offer or solicitation, nor regarded as recommendation to buy, sell or otherwise deal with any particular trade. If you are not sure about your local trading regulations, then you should leave this site immediately.`,
        footerpoint10:`You are strongly advised to obtain independent financial, legal and tax advice before proceeding with any trade. Nothing on this site should be read or construed as constituting advice on the part of Fxview or any of its affiliates, directors, officers or employees.`,
        footerpoint11:`The services of Fxview and the information on this site are not directed at residents of the Crimea, Cuba, Cyprus, India, Iran, North Korea, Sudan, Syria, and the United States and are not intended for distribution to, or use by, any person in any country or jurisdiction where such distribution or use would be contrary to local law or regulation.`,
        high_risk_warning:'High Risk Warning',
        open_a:'Open a',
        free_demo:'Free Demo',
        account_on:'Account',
        mt4:'MetaTrader 4',
        mt5:'MetaTrader 5',
        act:'ActTrader',
        or:'or',
        register:'Register',
        login:'Login',
        have_acc:'Have an account?',
        register_form:{
            otp_msg:'One-Time Pin has been sent to your email. Please enter it below.',
            open_an_account:'Open an Account',
            will_take_minut:'It will take less than a minute',
            select_residence_country:'Select Residence Country',
            email:'Email Address',
            pass:'Enter Password',
            cpass:'Confirm Password',
            privacy_agree:'By Signing up you agree to our',
            privacy_policy:'Privacy Policy',
        },
        website_use:'Website Use',
        cookies_policy:'Cookies Policy',
	    refund_policy:'Refund Policy',
	    AML_policy:'AML Policy',
        sub_heading1:{
            our:'Our',
            features:'Features',
            title:`Unleash your trading potential and conquer the market with our unbeatable trading conditions.`,
            sub_container1:{
                in_depth:'In-depth',
                learning:'Learning',
                description:'Enhance your trading by signing up to our free webinars and learn from experts. Our webinars are specifically designed to boost your market knowledge and hone your trading skills.',
            },
            sub_container2:{
                risk_free:`Risk-free`,
                trading:'Trading',
                description:`Whether you're new to trading or already an experienced forex trader, discover your trading prowess at Fxview, with our risk-free forex demo account.`,
            },
            sub_container3:{
                hundreds_of:'Hundreds of',
                tradable_instruments:'tradable instruments',
                description:'Gain access to over 500 trading products ranging from Fx to Commodities, Stocks, Indices, and digital assets.',
            },
            sub_container4:{
                real_prices_with:'Real prices with',
                fast_execution:'fast execution',
                description:'Experience real-time trading, explore a plethora of tools and strategies, and sharpen your skills all while trading in a completely risk-free demo account.',
            },
        },
        sub_heading2:{
            frequently_asked:'Frequently Asked',
            questions:'Questions',
            description:`Get Your Questions Answered: Your Ultimate Guide.`,
            more_info:'More Info',
            faq1:{
                question:`Is there a time limit to using a demo account?`,
                answer:`You can use the demo account for as long as you wish. The account only gets deactivated if there is no activity for 30 consecutive days.`,
            },
            faq2:{
                question:`Can I open multiple demo accounts with different trading platforms?`,
                answer:`Yes, you can. There is no limit on the number of demo accounts one can open with different platforms.`,
            },
            faq3:{
                question:`What’s the difference between a demo and live trading account?`,
                answer:`Live trading accounts need to be funded with real money for placing trades. Whereas demo accounts are funded with virtual money to eliminate the risk of losing real money. Other than this the trading conditions, tools, and features are almost the same for both demo and live accounts.`,
            },
            faq4:{
                question:`What’s the maximum amount I can trade in a demo account?`,
                answer:`You will get $100,000 to trade in the demo account. This amount gets refilled once the balance goes nil.`,
            },
            faq5:{
                question:`Can I practice CFD trading in a demo account?`,
                answer:`Yes, you are free to trade any instrument that we offer for live trading on your demo account.`,
            },
            faq6:{
                question:`Can I open multiple demo accounts?`,
                answer:`Yes, you can open multiple demo accounts with different platforms. But only one demo account can be opened for each type of account.`,
            },
            faq7:{
                question:`Is there an inactivity fee on demo account?`,
                answer:`No, we don’t charge any inactivity fee, but the demo account will be deactivated if not used for 30 consecutive days.`,
            },
        }
    },
    financial_details: 'Financial Details',
	reg_step_one_point: 'If employed please specify',
	reg_step_one_point_two: 'Estimated Annual Income (USD)',
	reg_step_one_point_three: 'Estimated Net Worth (USD)',
	reg_step_one_point_four: 'Source Of Funds',
	accountancy: 'Accountancy',
	admin_secretarial: 'Admin/Secretarial',
	auctions: 'Auctions',
	catering_hospitality: 'Catering/Hospitality',
	creative_media: 'Creative/Media ',
	education: 'Education',
	emergency_services: 'Emergency Services',
	engineering: 'Engineering',
	financial_services: 'Financial Services',
	gas_petrol: 'Gas/Petrol',
	health_medicine: 'Health/Medicine',
	army_industry: 'Army/Army Industry',
	hr: 'HR',
	insurance: 'Insurance ',
	legal: 'Legal',
	leisure_tourism: 'Leisure/Tourism ',
	manufacturing: 'Manufacturing ',
	marketing_pr_advertising: 'Marketing/PR/Advertising',
	pharmaceuticals: 'Pharmaceuticals ',
	precious_metals_Diamonds: 'Precious metals/Diamonds',
	property_construction_real_state: 'Property Construction/Real Estate ',
	retail: 'Retail',
	sales: 'Sales',
	social_care_services: 'Social Care/Services ',
	telecommunications: 'Telecommunications',
	transport_logistics: 'Transport/Logistics ',
	trust_charities_foundations: 'Trust/Charities/Foundations ',
	virtual_currency: 'Virtual Currency',
	other_please_specify: 'Other (Please specify)',
	till_ten_thousand: '0-30,000',
	till_fifty_thousand: '30,000-60,000',
	till_one_lac:'60,000-100,000',
	till_two_lac: '100,000-200,000' ,
	above_two_lac:'Above 200,000',
	zero_fiftythousand: '0-50,000',
	till_fiftythousand: '50,000-100,000',
	till_three_lac: '100,000-300,000',
	above_three_lac: '300,000+',
	employment: 'Employment',
	inheritance: 'Inheritance',
	investment: 'Investment',
	real_estate: 'Real Estate' ,
	savings: 'Savings',
	other: 'Other',
	reg_step_three: `Let's test your trading experience`,
	reg_step_three_point: 'As a regulated entity, we are required to assess whether you have appropriate understanding to trade leveraged products. Please complete your Appropriateness test carefully, as your responses will be used to determine whether you can open a Live trading account with us.',
	start_test: 'Start Test',
	
	"depMsz1": "处理时间：",
	"depMsz2": "1至5个工作日",
	"depMsz3": "费用：",
	"depMsz4": "0",
	"depMsz10": "即时 24/7",
	"MiniDepositAmount": "最低存款金额",
	"DntSkill": "你没有任何Skrill ID，请",
	"depMsz12": "更改您的 Skrill ID",
	"netId": "Netteller ID ：",
	"depMsz13": "不是正确的 Neteller 帐户？请",
	"depMsz14": "更改您的Netteller ID",
	"Clickhere": "单击此处。",
	"DntNetteler": "您没有任何Netteller ID，请",
	"Tocreate": "以创建。",
	"conPay": "确认存款",
	"depMsz15": "请确保存款详细信息正确无误。如果您对所有内容感到满意，请单击\"立即入金\"™按钮继续。请注意，如果您在存入账户后提款，您的资金很可能会退回到与存款相同的方式。",
	"accountId": "账户ID",
	"feeUsd": "费用（美元）",
	"depositAmount": "存款金额",
	"paymentMethod": "存款方式",
	"backToStep": "上一步",
	"procToPay": "继续付款",
	"personalInfo": "个人信息",
	"fname": "名字",
	"lname": "姓",
	"InvalidNumber": "无效号码",
	"saveContinue": "保存并继续",
	"termsAgreeRqd": "请同意条款以便继续",
	"googleOtp": "请输入 <strong>Google 身份验证器</strong>应用中显示的一次性密码。",
	"enterAmount": "输入金额",
	"allowDeposit1lac": "我们不允许模拟账户存款超过1，00，000",
	"SearchSomething": "在这里搜索",
	"search": "搜索",
	"Prev": "前一个",
	"Next": "下一个",
	"PleaseEnsureCorrect": "请确保详细信息正确无误",
	"lg_riskWarningMsg": "差价合约是复杂的工具，并且由于杠杆作用而具有快速亏损的高风险。绝大多数零售客户账户在交易差价合约时亏损。您应该考虑您是否了解差价合约的运作方式，以及您是否有能力承担损失资金的高风险。",
	"lg_welcomeMsgHeadone": "有竞争力的交易条件",
	"lg_welcomeMsg1": "受益于主要外汇对低至0.0点的点差，以及每单（单向）100，000美元1美元的佣金。",
	"lg_welcomeMsgHeadtwo": "我们的平台",
	"lg_welcomeMsg2": "在我们快速可靠的平台上访问世界上最受欢迎的市场 - MT4，MT5和ActTrader",
	"lg_welcomeMsgHeadthree": "交易工具",
	"lg_welcomeMsg3": "访问各种交易工具，如自动图表，交易者™工具箱，API交易等",
	"lg_signin": "登录 Fxview",
	"lg_emailaddress": "电邮地址",
	"lg_EmailfieldValid": "请输入有效的电子邮件地址",
	"lg_EmailfieldReq": "电子邮件字段为必填项",
	"lg_password": "密码",
	"lg_logIn": "登录",
	"lg_forgotPassword": "忘记密码",
	"lg_donthaveaccount": "™没有帐户？",
	"lg_signuphere": "在此注册",
	"lg_charlgateMsGlobal": "Finvasia Capital South Africa (PTY) Ltd 公司在南非注册，公司编号为 2018/303451/07。注册办公地址为 3rd Floor, 34 Whiteley Blvd, Melrose Arch, Birnam, 2196。",
	"lg_charlgateMsEurope": "Charlgate Ltd由CySEC授权和监管，许可证号为367/18，公司注册号为372060。",
	"lg_varify2step": "两步验证",
	"lg_EnterAuthCode": "输入验证码",
	"lg_submit": "提交",
	"lg_backLogin": "返回登录",
	"lg_footerMsz2": "您的资金面临风险。您可能会损失所有投资资本。",
	"lg_riskDisclaimer": "风险免责声明",
	"fp_forgotPasswordText": "请在fxview中输入您的注册电子邮件地址，以便我们帮助您创建新密码。",
	"fp_resetPassword": "重置密码",
	"fp_RESEND_EMAIL": "重新发送电子邮件",
	"fp_backLogin": "返回登录页面",
	"fp_charlgateMsg": "Charlgate Ltd拥有 fxview.com。 Charlgate Ltd是一家由塞浦路斯证券交易委员会CySEC（CySEC许可证号367/18和公司注册号：372060）授权和监管的公司，也是投资者赔偿基金（ICF）的成员。",
	"reg_welcomemsg1": "<h3>点差</h3><p>从0.0点起</p>",
	"reg_welcomemsg2": "<h3>每 $100K</h3><p> 佣金 1 美元</p>",
	"reg_welcomemsg3": "<h3>多种交</h3><p>易工具</p>",
	"reg_welcomemsg4": "<h3>超快</h3><p>速执行</p>",
	"reg_welcomemsg5": "<h3>100%</h3><p>存款奖金</p>",
	"reg_openacc": "开立账户",
	"reg_takeminute": "这将需要不到一分钟的时间",
	"reg_selectacctype": "选择账户类型",
	"reg_selectcountry": "选择居住国",
	"reg_Enterfname": '輸入名字',
	"reg_Enterlname": '輸入姓氏',
	"reg_Entername": '輸入你的名字',
	"reg_Enteremail": "输入电子邮件地址",
	"reg_Enterpwd": "输入密码",
	"reg_passwordFieldReq": "密码字段为必填项",
	"reg_passCharVal": "您的密码必须至少包含 6 个字符，并且至少包含 1 个数字、1 个大写字符和 1 个特殊字符 （！@#$%^*）",
	"reg_conPassword": "确认密码",
	"reg_ConfpasswordReq": "确认密码字段为必填字段。",
	"reg_newConfFieldSame": "输入的密码不匹配。请重试",
	"reg_captchaErr": "验证码无效",
	"reg_register": "注册",
	"reg_signagree": "通过注册，您同意我们的",
	"reg_privacyPolicy": "隐私策略",
	"reg_haveAccount": "有帐户？",
	"reg_login": "登录",
	"reg_registerMsz2": "一次性 PIN 码已发送到您的电子邮件。请在下面输入。",
	"reg_enterOtp": "输入一次性密码",
	"reg_submit": "提交",
	"reg_resendotp": "重新发送一次性密码",
	"rp_passwordHashMsz2": "密码已成功更改。点击",
	"rp_here": "这里",
	"rp_toLogin": "登录",
	"rp_otherWayHelp": "获取帮助的其他方式",
	"rp_chatWithUs": "与我们聊天",
	"rp_or": "或",
	"rp_callUs": "致电我们",
	"prof_verified": "验证",
	"prof_undrreview": "您的申请正在审核中！",
	"prof_checkstatus": "请查看您的问题状态",
	"prof_clickhere": "点击这里",
	"prof_completeRegister": "完成注册",
	"prof_basicDetail": "基本信息",
	"prof_addressDetail": "地址信息",
	"prof_paymentDetail": "付款明细",
	"prof_documents": "文件",
	"prof_fname": "名字",
	"prof_lname": "姓",
	"prof_DOB": "出生日期",
	"prof_phone": "电话",
	"prof_Member": "成员",
	"prof_companyname": "公司名称",
	"prof_incorporationdate": "成立日期",
	"prof_currency": "货币",
	"prof_emailaddress": "电邮地址",
	"prof_PEP": "政治公众人物",
	"prof_addressLine1": "住宅地址行 1",
	"prof_addressLine2": "住宅地址行 2",
	"prof_postCode": "邮 编",
	"prof_city": "城市或城镇",
	"prof_resCountry": "居住国家",
	"prof_bankName": "银行名称：",
	"prof_AccNumber": "账户号码：",
	"prof_Pending": "待定",
	"prof_Disable": "禁用",
	"prof_viewDetail": "查看详情",
	"prof_paymentMethod": "存款方式",
	"prof_AccountName": "帐户名称",
	"prof_SwiftCode": "银行/BIC/排序代码",
	"prof_IBAN": "银行账户号码",
	"prof_bankAdd": "银行地址：",
	"prof_onlinePayId": "在线支付编号：",
	"prof_Change": "改变",
	"prof_CreditCard": "信用卡号码：",
	"prof_ExpiryDate": "有效期：",
	"prof_noBankDetail": "没有银行详细信息",
	"prof_AddBank": "添加银行",
	"prof_AddCard": "添加信用卡",
	"prof_noDocuments": "暂无文档",
	"prof_disablecard": "请禁用我的信用卡付款方式，信息如下：",
	"prof_creditcardno": "信用卡号码 ： **** **** ****",
	"prof_bankpaymentmethod": "请禁用我的银行转帐付款方式，信息如下：",
	"prof_diablepaymentmethod": "禁用付款方式",
	"prof_addpeymentmethod": "添加付款方式",
	"twoFA_faText": "双因素身份验证",
	"twoFA_alreadyEnabled": "启用",
	"twoFA_setUp2FA": "设置 2FA",
	"twoFA_clickToDisable": "单击以禁用",
	"twoFA_clickToEnable": "单击以启用",
	"twoFA_enable2FaText": "启用双因素身份验证",
	"twoFA_accounntSafe3Steps": "通过3个简单的步骤使您的帐户更安全：",
	"twoFA_downloaduthApp": "下载身份验证器应用程序",
	"twoFA_downloaduthAppText": "将Authy或Google身份验证器下载并安装到您的手机或平板电脑上。",
	"twoFA_scanQrCode": "扫描二维码",
	"twoFA_scanQrCodeText": "打开身份验证应用程序，然后使用手机的摄像头扫描左侧的图像。",
	"twoFA_loginYourCode": "使用您的代码登录",
	"twoFA_enter6DigitCode": "输入生成的 6 位数验证码。",
	"twoFA_activate": "激活",
	"twoFA_enterOtpDisableQrCode": "请输入OTP以禁用QR码",
	"twoFA_disableCodeText": "使用您的代码禁用",
	"cp_changePassword": "更改密码",
	"cp_oldpwd": "旧密码",
	"cp_newPassword": "新密码",
	"cp_conPassword": "确认密码",
	"cp_passCharval": "您的密码必须至少包含 6 个字符，最多 15 个字符，并且至少包含 1 个数字、1 个大写字符和 1 个特殊字符 （！@#$%^*）",
	"welcm_fewStepAway": "你只有几步之遥",
	"welcm_activateFxviewAccountNow": "立即激活您的Fxview账户！",
	"welcm_setupFxViewAcc": "设置您的 fxview 帐户",
	"welcm_modify": "修改",
	"welcm_addFund": "添加资金",
	"welcm_startTrading": "开始交易",
	"welcm_welcomeFxView": "欢迎来到Fxview！",
	"welcm_welFxviewCon": "您几乎已经准备好开始交易了。请完成您的交易账户申请并上传必要的身份证明文件。",
	"welcm_completeReg": "完成注册",
	"welcm_tryDemoAcc": "尝试模拟账户",
	"welcm_tryDemoAccCon": "试试我们的交易平台 - MT4，MT5和ActTrader - 并发展您的差价合约交易技能。练习使用虚拟资金进行交易",
	"welcm_createDemoAccount": "模拟账户",
	"welcm_downloadPlatform": "下载平台",
	"welcm_MT4": "Meta Trader 4",
	"welcm_winIosAndroid": "Windows/IOS/Android",
	"welcm_MT5": "Meta Trader 5",
	"welcm_actTrader": "<sup>ActTraderTM</sup>",
	"welcm_rangeTradTools": "交易工具的范围",
	"welcm_wlcmMsz1": "根据图表模式、突破、趋势反转、斐波那契形态和技术指标识别自动生成的交易理念。",
	"welcm_wlcmMsz2": "探索基于各种资产类别的多种图表模式和技术指标认可的广泛可操作的交易理念。",
	"welcm_wlcmMsz3": "通过实时财经新闻和地缘政治事件更新保持领先一步，做出明智的交易决策。",
	"welcm_wlcmMsz4": "及时了解最新的经济日历，其中包含即将到来的关键全球经济事件和指标。",
	"welcm_wlcmMsz5": "通过合适的VPS托管程序获得无与伦比的交易体验，让您以更低的延迟不间断地进行交易。",
	"welcm_SeeMore": "查看更多",
	"notif_Notification": "通知",
	"notif_noNewNotification": "无新通知",
	"verf_reqProcessing": "请求处理...",
	"verf_reqVerify": "请求验证",
	"verf_dear": "亲爱的",
	"verf_requestVerifyWith": "您的提款请求已成功处理",
	"verf_backWithList": "返回提款列表",
	"verf_reqFailed": "请求失败",
	"verf_msg": "您的提款请求已失败",
	"refer_Refera": "参考一个",
	"refer_friend": "朋友",
	"refer_opportunity": "我们的推荐朋友计划让您有机会为您推荐的每位朋友赚取20美元。™更重要的是，当您的朋友使用您的邀请电子邮件注册时，他们也将获得20美元的奖励。",
	"refer_Refernow": "立即参考",
	"refer_howorks": "它是如何运作的",
	"refer_everyclient": "对于您推荐的每个客户，我们将奖励您20美元。与您的朋友分享您最喜欢的关于fxview的事情，并在我们这里享受额外的交易保证金。",
	"refer_stepmsg1": "注册或登录您的fxview账户",
	"refer_stepmsg2": "使用客户专区中的表单邀请您的朋友",
	"refer_stepmsg3": "您的朋友将收到一封电子邮件邀请，并将按照步骤进行注册",
	"refer_stepmsg4": "一旦您和您的朋友为他们的帐户注入 200 美元或更多资金，您和您的朋友都会收到 20 美元",
	"refer_referEmail": "推荐电子邮件",
	"refer_addmore": "添加更多",
	"refer_nowrefer": "立即参考",
	"refer_successRefer": "您已成功推荐",
	"refer_refrMore": "更多推荐",
	"refer_godashboard": "转到仪表板",
	"refer_partnerprog": "我们的其他合作伙伴计划",
	"refer_Affilialte": "会员计划",
	"refer_uniquelink": "获取您独特的推荐链接",
	"refer_trackearn": "跟踪您的推荐收入",
	"refer_monitorStatus": "监控您的推荐状态",
	"refer_withdrawearn": "根据需要提取您的收入",
	"refer_register": "注册",
	"refer_knowmore": "了解更多",
	"refer_brokerprogram": "介绍经纪人计划",
	"refer_uniqueIB": "独特的IB门户",
	"refer_IBmanager": "专属IB经理",
	"refer_controlearn": "掌控您的收入",
	"refer_regislink": "唯一的IB注册链接",
	"refer_clientlist": "客户列表",
	"refer_email": "电子邮件",
	"refer_accountStatus": "账户阶段",
	"refer_volumereq": "交易量要求",
	"refer_tradedvol": "交易量",
	"refer_qualified": "合格",
	"refer_action": "行动",
	"refer_successDelete": "您已成功删除",
	"refer_fromReflist": "从您的推荐人列表中",
	"refer_wantTodelete": "是否要删除",
	"refer_confrm": "确认",
	"refer_enterEmailrefer": "请输入电子邮件进行参考",
	"refer_error": "错误",
	"refer_errorReferal": "在推荐之前，您必须经过验证和资助。",
	"dash_overview": "概述",
	"dash_traderRoom": "交易室",
	"dash_personalInfo": "个人信息",
	"dash_declaration": "声明",
	"dash_uploadDocumen": "上传个人文档",
	"dash_completeReg": "完成注册",
	"dash_checkticketstatus": "请检查您的问题状态。",
	"dash_clickhere": "点击这里",
	"dash_TradingAcc": "交易账户",
	"dash_live": "真实",
	"dash_demo": "模拟",
	"dash_Platform": "平台",
	"dash_tradAccId": "账户编号",
	"dash_Leverage": "杠杆作用",
	"dash_currency": "货币",
	"dash_marketSummary": "市场摘要",
	"dash_marketInsight": "市场洞察",
	"dash_news": "新闻",
	"dash_EconomicCal": "财经日历",
	"dash_thereIsNoRecord": "未找到记录",
	"dash_Time": "时间",
	"dash_Country": "国家",
	"dash_event": "事件",
	"dash_frequency": "频率：每月",
	"dash_autochartist": "自动图表",
	"dash_nodata": "暂无数据",
	"dash_time": "时间",
	"dash_impact": "冲击",
	"dash_actual": "实际",
	"dash_forecast": "预测",
	"dash_previous": "以前",
	"dp_download": "下载",
	"dp_actTrader": "<sup>ActTraderTM</sup>",
	"dp_forWindows": "适用于Windows",
	"dp_forIos": "适用于 iOS",
	"dp_forAndroid": "安卓版",
	"dp_ActWebTrader": "Act Web 交易者",
	"dp_MT4WebTrader": "MT4网页版交易者",
	"dp_forMAC": "适用于 MAC",
	"dp_MT5WebTrader": "MT5网络交易者",
	"forWindows": "Windows",
	"forIos": "苹果系统",
	"WEB": "Web",
	"acc_Aclist": "账户列表",
	"acc_changeLeverage": "更改杠杆",
	"acc_changeplatPass": "更改平台密码",
	"acc_InternalTrans": "内部转账",
	"bnk_bankDetails": "银行详细信息",
	"bnk_MicrCode": "Micr 代码：",
	"bnk_IBANNumber": "IBAN 帐号",
	"bnk_ifscSwiftBic": "ifsc/Swift/Bic（英国的短代码）",
	"bnk_Save": "保存",
	"db_requestBon": "申请奖金",
	"db_removeBon": "删除奖金",
	"db_bonusList": "奖金列表",
	"bver_bonusVerMsz1": "您的奖金申请已成功处理。",
	"bver_backBonusList": "返回奖金列表",
	"bver_reqFailed": "请求失败",
	"bl_bonusList": "奖金列表",
	"bl_created": "日期",
	"bl_amount": "数量",
	"bl_bonusType": "奖金类型",
	"bl_status": "状态",
	"bl_comments": "评论",
	"bl_complete": "完成",
	"bl_pending": "待定",
	"rb_removeBonus": "删除奖金",
	"rb_removebonusMsz1": "很抱歉，您没有资格删除奖金。",
	"rb_availbonus": "可用奖金：",
	"rb_bonusremove": "输入要删除的奖金金额",
	"rb_submit": "提交",
	"rb_googleAuth1": "请输入显示在",
	"rb_googleAuth2": "谷歌身份验证器",
	"rb_googleAuth3": "应用程序",
	"rb_validate": "验证",
	"rb_googleAuth4": "您的双因素身份验证代码遇到问题？",
	"rb_googleAuth5": "单击此处通过电子邮件进行验证",
	"rb_googleAuth6": "我们已发送指向您的电子邮件的链接",
	"rb_bonusGoogleAuth": "请点击链接以继续提款",
	"rb_googleAuth7": "收件箱或垃圾邮件文件夹中没有收到电子邮件？发送",
	"rb_googleAuth8": "您的帐户未启用双重身份验证。",
	"rb_googleAuth9": "双因素身份验证增加了额外的安全层，确保真正由您尝试在fxview帐户中进行更改。",
	"rb_googleAuth10": "单击此处启用谷歌身份验证",
	"rb_congo": "祝贺",
	"rb_removeBonusCongoMsz": "已成功删除交易ID的奖金",
	"rb_goToDash": "转到仪表板",
	"rb_noTradingAccFound": "未找到真实交易账户！",
	"rb_plzWaitWhileProc": "在我们处理您的数据时，请稍候...",
	"rb_bonusGooglerequest": "请点击链接以继续您的奖金请求",
	"rb_bonusGoogleremove": "请点击链接以继续",
	"req_bonus": "奖金",
	"req_bonusMsz1": "很抱歉，您不符合资格。为您的帐户注资以利用奖金。",
	"req_allowMaxBonus": "允许的最高奖金",
	"req_amount": "数量",
	"req_agreeTerms": "我同意 条款和条件",
	"reg_Agreee": "我同意",
	"reg_TERMS": "条款及细则",
	"req_fieldReq": "字段为必填项",
	"req_maxlev": "允许使用100%存款奖金的最大杠杆为300X。",
	"req_tochangeleverage": "更改您的杠杆",
	"req_bonusMsz2": "已成功为交易 ID 添加赠金：",
	"req_availBonus": "使用奖金",
	"req_allowBonus": "允许的奖金",
	"req_goBackMangeAcc": "转到管理帐户",
	"req_noTradingAccFound": "未找到真实交易账户！",
	"req_minBonus": "最低存款奖金为200美元，我们可以选择存款",
	"req_maxAmount": "您可以要求奖金的最高金额为",
	"rb_ReadPolicy": "阅读我们的奖金政策",
	"dep_acc_fund_depFundAcc": "将资金存入账户",
	"dep_acc_fund_tradAccId": "交易账户编号",
	"dep_acc_fund_depFund": "存入资金",
	"dep_acc_fund_selDepMet": "选择存款方式",
	"dep_acc_fund_depFieldReq": "存款方法字段为必填项",
	"dep_selectbankaccount": "请选择银行账户 ：",
	"dep_acc_fund_lessDet": "细节较少",
	"dep_acc_fund_viewDet": "查看详情",
	"dep_holderName": "持有人姓名：",
	"dep_sortCode": "排序代码",
	"dep_reference": "参考",
	"dep_fortradaccount": "对于交易账户",
	"dep_selectAcc": "请选择帐户",
	"dep_acc_fund_DontbankAcc": "您没有任何银行账户，请",
	"dep_acc_fund_clkHere": "点击这里",
	"dep_Createbank": "创建新银行",
	"dep_acc_fund_MinDepAmt": "最低存款金额",
	"dep_acc_fund_SpeDepAm": "指定存款金额",
	"dep_mindepositallow": "允许的最低存款额",
	"dep_acc_fund_bakStp": "上一步",
	"dep_acc_fund_procToPay": "继续付款",
	"dep_ticketHasbeenCreated": "您的查询单据已创建",
	"dep_proMsz19": "前往单据",
	"dep_acc_fund_PlsEnsCort": "请确保详细信息正确无误",
	"dep_acc_fund_accountId": "账户号码/钱包号码",
	"dep_acc_fund_feeUsd": "费用（美元）",
	"dep_acc_fund_depAmt": "存款金额",
	"dep_acc_fund_depMeth": "存款方式",
	"dep_acc_fund_noTrdAccFnd": "未找到真实交易账户！",
	"dep_acc_fund_plzWaitWhileProc": "在我们处理您的数据时，请稍候...",
	"dep_maxlimit": "您提高了每月的最高交易限额",
	"dep_maxdeposit": "您可以存入最高金额=",
	"dep_pleaseDeposit": "我想存款",
	"dep_pleaseDeposit1": "从银行详细信息，如下<br>所述",
	"dep_AccNumber": "账户号码 ：",
	"dep_holdername": "<br> 持有人姓名 ：",
	"dep_bankname": "<br> 银行名称 ：",
	"dep_brsortCode": "<br> 排序代码 ：",
	"dep_brbankAdress": "<br> 银行地址 ：",
	"dep_depositDone": "存款成功完成",
	"dep_depositFail": "存款失败",
	"dl_depositList": "存款清单",
	"dl_transId": "交易编号",
	"dl_status": "地位",
	"dl_Method": "方法",
	"dl_type": "类型",
	"dl_created": "日期",
	"dl_action": "行动",
	"dt_depTransHist": "存款交易记录",
	"dt_payMeth": "支付方式",
	"dt_clickToResolve": "点击解决",
	"dw_acc_fund_selDepMet": "选择存款方式",
	"dw_acc_fund_depFieldReq": "存款方法字段为必填项",
	"dw_selectaccount": "请选择银行账户 ：",
	"dw_acc_fund_lessDet": "更少细节",
	"dw_acc_fund_viewDet": "查看详情",
	"dw_holderName": "持有人姓名：",
	"dw_bankName": "银行名称：",
	"dw_bankAdd": "银行地址：",
	"dw_sortCode": "排序代码",
	"dw_reference": "参考",
	"dw_fortradingAcc": "对于交易账户",
	"dw_acc_fund_DontbankAcc": "您没有任何银行账户，请",
	"dw_Createbank": "创建新银行",
	"dw_acc_fund_MinDepAmt": "最低存款金额",
	"dw_acc_fund_SpeDepAm": "指定存款金额",
	"dw_acc_fund_PlsEnsCort": "请确保详细信息正确无误",
	"dw_acc_fund_accountId": "账户编号",
	"dw_acc_fund_feeUsd": "费用（美元）",
	"dw_acc_fund_depAmt": "存款金额",
	"dw_acc_fund_depMeth": "存款方式",
	"dw_proMsz19": "前往单据",
	"dw_acc_fund_plzWaitWhileProc": "在我们处理您的数据时，请稍候...",
	"dw_bankCode": "<br> 银行代码 ：",
	"acc_reqProcessing": "请求处理...",
	"acc_accountVerMsz1": "请求已成功处理",
	"acc_backAccountList": "返回帐户列表",
	"acc_reqFailed": "请求失败",
	"acclist_myAccounts": "我的帐户",
	"acclist_liveAccount": "真实账户",
	"acclist_demoAccount": "模拟账户",
	"lev_changeLeverage": "更改杠杆",
	"lev_exsistLev": "现有杠杆",
	"lev_newLev": "新杠杆",
	"lev_backManageAccount": "返回管理帐户",
	"lev_levMsz1": "请点击链接更改您的杠杆。",
	"lev_levMsz2": "您的交易账户杠杆已成功更改",
	"lev_tradingId": "交易理念",
	"lev_oldLev": "旧杠杆",
	"lev_goBackMangeAccv": "转到管理帐户",
	"lev_noDemoLiveTradingAccFound": "未找到交易账户！",
	"lev_waitforVerf": "请等待验证。",
	"levPwd_passMsz1": "请点击链接更改您的密码",
	"lePwd_passMsz2": "您的交易账户密码已成功更改",
	"lePwd_oldPassword": "旧密码",
	"Dlist_demoLive": "模拟/真实",
	"Dlist_accountType": "账户类型",
	"Dlist_leverage": "杠杆作用",
	"detch_detachaccount": "分离帐户：",
	"detch_fourfive": "454579",
	"detch_pamMaster": "Pamm master",
	"detch_todd": "Tod Anderson",
	"detch_balance": "余额",
	"detch_equity": "净值",
	"detch_freeMargin": "可用保证金",
	"detch_MarginUSed": "已用保证金",
	"detch_pnl": "盈亏",
	"detch_two": "$2,000 ",
	"detch_eight": "$800 ",
	"detch_twelve": "$1,200 ",
	"detch_three": "$300 ",
	"detch_twofive": "($250)",
	"detch_takenote": "请注意以下几点",
	"detch_openPosition": "所有未平仓头寸将在分离账户之前关闭。",
	"detch_finalPnl": "最终的盈亏可能会因市场情况而异。",
	"detch_afterOpen": "未平仓头寸关闭后，将计算管理，订阅成本，绩效费并从账户中扣除（如果有）。",
	"detch_terms": "我接受上述条款和条件",
	"detch_confirm": "确认",
	"It_oneRecord": "您只有一条记录。在尝试内部转账之前，请至少再创建一个交易账户或钱包",
	"It_liveAcc": "真实账户",
	"It_wallet": "钱包",
	"It_internalTransfer": "内部转账",
	"It_confToTransfer": "请确认以继续",
	"It_back": "返回",
	"It_freeMargin": "可用保证金",
	"It_interTransSorryMsz": "很抱歉，您没有余额将金额转移到另一个交易账户。",
	"It_transToAcc": "转账至账户编号",
	"It_fieldReq": "字段为必填项",
	"It_currentBalance": "当前余额",
	"It_pleseEnterAmount": "请输入金额",
	"It_submit": "提交",
	"It_intTransMsz2": "请点击链接确认您的内部转账",
	"It_intTransMsz3": "转账已成功完成",
	"It_fromTradId": "从交易 ID",
	"It_towallet": "到钱包",
	"It_toTradId": "转至交易编号",
	"It_transferAmount": "转账金额",
	"It_backinternalTrans": "返回内部传输",
	"It_interTransDeducted": "将从您的",
	"It_depostotradAcc": "将存入您的",
	"Itwallet_backwallet": "返回钱包",
	"Itwallet_cancel": "取消",
	"Itwallet_fromwal": "从钱包",
	"Itwallet_towal": "到钱包",
	"Itwallet_backtowallet": "返回钱包",
	"sub_SubliveAcc": "订阅真实账户",
	"sub_subscribe": "订阅",
	"sub_backtradingTool": "返回交易工具箱",
	"sub_enterotp": "输入 Otp",
	"sub_validate": "驗證",
	"sub_resendOtp": "重新发送 Otp",
	"sub_congo": "祝贺",
	"sub_tradingId": "交易编号",
	"sub_addtradertool": "请添加添加交易者工具箱，account_id以下详细信息<br>：",
	"re_marketinsight": "市场洞察",
	"re_news": "新闻",
	"edu_learnTrade": "学习交易",
	"edu_offerEdu": "我们为您提供教育资源，以了解有关交易的所有知识。我们的学习材料迎合所有知识水平，使您能够增强对全球市场，在线交易和我们的交易工具的理解。我们全面的交易主题列表从基础到高级，将帮助您将交易提升到更高的水平。",
	"edu_Enhance": "通过利用我们的教育资源，增强您对全球市场的理解，将您的交易提升到一个新的水平。Fxview教育提供了广泛的主题列表，迎合了从初学者到高级各级交易者的广泛主题，涵盖了市场如何运作，以及如何使用我们的交易工具来发挥您的优势。",
	"edu_tradeconfidence": "您将通过专注于交易/投资的技术和基本面，在我们的帮助和支持下，学习自信地进行交易",
	"edu_basic": "基本",
	"edu_advance": "高深",
	"edu_general": "常规",
	"edu_forex": "外汇",
	"edu_commodities": "商品",
	"edu_indices": "指标",
	"edu_stocks": "存货",
	"edu_thereIsNoRecord": "未找到记录",
	"marin_source": "资料来源：HoopsAI",
	"marin_loadmore": "加载更多",
	"marin_loadwait": "正在加载，请稍候...",
	"news_marketnews": "市场新闻",
	"news_fearurednews": "特色新闻",
	"news_market": "市场",
	"news_nodata": "暂无数据",
	"news_latestnews": "最新消息",
	"video_video": "视频",
	"video_tut": "教程",
	"video_intrestedforex": "对外汇交易感兴趣？您来对地方了。Fxview提供了一系列视频教程，以帮助您发展技能并学习像专业人士一样进行交易。我们的分步指南包括有关注册，账户验证，基本外汇术语，交易平台功能等的说明。",
	"video_allvideo": "所有视频",
	"video_fxviewtut": "Fxview 教程",
	"video_platTut": "平台教程",
	"video_forexBasic": "外汇基础知识",
	"video_whatisforex": "什么是外汇",
	"web_webinars": "网络研讨会",
	"web_enhancetrad": "通过注册我们的免费网络研讨会和向专家学习来增强您的交易。我们的网络研讨会专门用于提高您的市场知识并磨练您的交易技能。专家揭示了关键的交易策略和概念，这对初学者和有经验的交易者都有好处。",
	"web_registeran": "注册一个",
	"web_upcomingweb": "即将举行的网络研讨会",
	"web_register": "注册",
	"web_timeleft": "剩余时间",
	"web_days": "日",
	"web_hours": "小时",
	"web_mins": "分钟",
	"web_secs": "秒",
	"web_webnar": "网络研讨会",
	"web_library": "图书馆",
	"web_higherpower": "趋势线-网络研讨会",
	"web_aprtwenty": "（9th 八月 2021）",
	"web_findright": "支撑和阻力-网络研讨会",
	"web_aprsixteen": "（11th 八月 2021）",
	"web_weekahead": "基本指标-网络研讨会",
	"web_aprtwelve": "（13th 八月 2021）",
	"web_introTrend": "趋势指标简介 - 网络研讨会",
	"web_apreighteen": "三月 18th",
	"web_topicdiscuss": "讨论主题",
	"web_correlation": "FXVIEW-使用相关性来改善您的交易",
	"web_datemay": "2021年5月11日 12：00 - 12：40 pm 格林威治标准时间",
	"web_showlocal": "显示我的当地时间",
	"web_joinfxview": "加入Fxview专家，他将为您提供有关使用相关性的见解，以提高您的交易技能。",
	"web_secureplace": "与行业专家一起确保您的位置，并学习如何成为专业的外汇交易者",
	"web_topicsCovered": "网络研讨会期间要涵盖的主题",
	"web_strongweak": "#NAME?",
	"web_corrmultiple": "#NAME?",
	"web_posneg": "#NAME?",
	"ForexGlossarySpan": "外汇<span>词汇表</span>",
	"ForexGlossaryGuide": "Fxview的外汇词汇表是一个完整的指南，可帮助您学习基本的外汇术语并熟悉交易者的术语。",
	"AGGREGATE_DEMAND": "总需求",
	"text": "它是衡量一个经济体/部门中所有制成品和服务总需求的经济衡量标准。它表示当前价格水平与一个国家™的实际GDP（国内生产总值）的关系。",
	"APPRECIATION": "升值",
	"AppText": "它是指一种货币相对于另一种货币的价值因市场需求而增加。",
	"ARBITRAGE": "套汇",
	"ArbText": "在一个市场购买金融资产并在另一个市场同时出售以从价格差异中受益被称为套利。",
	"AROUND": "周围",
	"ArndText": "当远期溢价/折扣接近平价时报价时使用的经销商行话。例如，\"两个左右\"将转换为当前位置两侧的 2 个点。",
	"ASK_RATE": "卖出价",
	"Asktext": "出售金融工具的利率/价格。",
	"ASSET_ALLOCATION": "资产配置",
	"AsstText": "一种投资策略，旨在根据投资者的目标，通过将资金分配给不同的股票，债券，商品，货币和其他资产类别来平衡风险和回报。",
	"Back_office": "后台",
	"BalanceofTrade": "贸易差额",
	"BarCharts": "条形图",
	"BaseCurrency": "基础货币",
	"BearMarket": "熊市",
	"BidRate": "投标价格",
	"btext1": "各部门检查所有结算和相关流程",
	"btext2": "一个国家的™出口和进口之间的价值差额。",
	"btext3": "条形图在金融市场中用于将价格变动传达到易于阅读的图表中。它们基本上是用于绘制价格图表的OHLC图形图表。图表上有一个刻度，它提供开盘，最高价，最低价和收盘价的给定时间段内的价格。",
	"btext4": "一种出现在外汇对报价中的货币。外汇市场中总是有一种货币，它总是相对于另一种货币报价，因为您同时买入一种货币，同时卖出另一种货币。基础货币将首先显示，然后是第二个（报价）货币。例如，如果您正在查看欧元/美元货币对，这里的基础货币是欧元，报价货币是美元。",
	"btext5": "一个以价格下跌为特征的市场。",
	"btext6": "买家愿意支付的最高价格。",
	"CABLE": "英镑和美元货币对",
	"CABLEText": "用于英镑/美元货币对的昵称。该术语的起源是因为该汇率最初是从1800年代中期开始通过跨大西洋电缆传输的™，当时英镑是国际贸易的货币。",
	"CANDLESTICK_CHART": "蜡烛图",
	"CANDLESTICK_CHARTText": "也称为日本蜡烛图，是一种条形图，主要用于描述证券，衍生品或货币的价格走势。每个\"烛台\"通常显示一天，代表开盘价和收盘价之间的差异。如果开盘价高于收盘价，则蜡烛/矩形为阴影。如果收盘价高于开盘价，则该图表区域不带阴影。",
	"CENTRAL_BANK": "中央银行",
	"CENTRAL_BANKText": "监督一个国家的™货币政策和印刷货币的政府或准政府组织。例如，联邦银行储备银行（美国），欧洲中央银行（欧洲），澳大利亚储备银行（澳大利亚）。",
	"CHARTISTs": "宪章",
	"CHARTISTsText": "个人（也称为技术交易者），使用图表和图形来解释历史数据，以查找趋势并预测未来的价格走势。",
	"CHOICE_MARKET": "选择市场",
	"CHOICE_MARKETText": "也称为锁定市场，它是一个没有点差的市场。这意味着一种货币可以以与在市场上出售相同的价格购买。",
	"CLEARING": "空地",
	"CLEARINGtext": "对账或结算各种金融工具的购买和销售的过程。",
	"CONTAGION": "传染",
	"CONTAGIONText": "经济危机从一个市场蔓延到另一个市场的趋势。",
	"COLLATERAL": "旁系的",
	"COLLATERALText": "借款人为获得贷款或作为履约保证而给予的东西。",
	"COMMISSIONs": "委员会",
	"COMMISSIONText": "经纪人向交易者/投资者收取的交易费。",
	"CONFIRMATION": "确认",
	"CONFIRMATIONText": "交易对应方交换的文件，说明所述交易的条款。",
	"CONTRACTunit": "合约（单位或手数）",
	"CONTRACTunitText": "交易的标准单位。",
	"COUNTERPARTY": "交易对手",
	"COUNTERPARTYText": "参与者之一，银行或客户，与他们进行金融交易。",
	"COUNTRY_RISK": "国家风险",
	"COUNTRY_RISKText": "与跨境交易相关的风险，如战争等法律和政治条件。",
	"CROSS_RATES": "交叉费率",
	"CROSS_RATESText": "两种货币之间的汇率不涉及美元。在货币对报价的国家，交叉汇率被认为是非标准的。",
	"CURRENCYe": "货币",
	"CURRENCYText": "一种由政府/中央银行发行的纸币、金属或数字形式的交换手段，用作法定货币。",
	"CURRENCY_RISK": "货币风险",
	"CURRENCY_RISKText": "因汇率不利变化而蒙受损失的风险。",
	"Day_trading": "日间交易",
	"Day_tradingText": "涉及在同一天内开仓和平仓的交易策略。",
	"Dealer": "交易人",
	"DealerText": "作为交易委托人或交易对手的人。本金基本上是在一边，希望通过在与另一方的后续交易中平仓来赚取良好的利润。",
	"Deficit": "赤字",
	"DeficitText": "一国的进口成本超过其出口成本的金额，也称为贸易负差额。",
	"Delivery": "交货",
	"DeliveryText": "通过交付资金结算交易。OR 合约到期日，即通过交换货币进行交易的最终结算。",
	"Depreciation": "折旧",
	"DepreciationText": "由于市场条件或其他因素，一种™货币相对于另一种货币的价值下降。",
	"Derivative": "导数",
	"DerivativeText": "衍生品的价值来自标的资产的价格，通常被交易者用作推测资产未来价格走势的工具，而无需购买资产本身。期权是最常见的衍生工具。",
	"Devaluation": "贬值",
	"DevaluationText": "当一种货币相对于一种或多种其他货币的价值下降时，货币™就会贬值。",
	"ECONOMIC_INDICATOR": "经济指标",
	"ECONOMIC_INDICATORText": "由政府或非政府机构发布的统计指标，表明一个经济体的经济状况，如GDP，外国投资，贸易逆差，就业率等。",
	"ENDOFDAYORDER": "结束订单",
	"ENDOFDAYORDERText": "以指定价格买入或卖出的订单，该订单仅在交易日结束前开放，通常是下午5点/纽约时间17：00。",
	"EUROs": "欧元",
	"EUROsText": "欧洲货币联盟（EMU）的货币。",
	"EUROPEANCENTRALBANK": "欧洲中央银行",
	"EUROPEANCENTRALBANKText": "它成立于1998年，是欧洲货币联盟（EMU）的中央银行。",
	"FederalDepositInsurance": "联邦存款保险公司",
	"FederalDepositInsuranceText": "一个独立的联邦机构，保护消费者和美国金融体系。FDIC是存款保险最知名的，因为它们可以帮助客户在银行倒闭时避免损失。",
	"FederalReserveSystem": "联邦储备系统",
	"FederalReserveSystemText": "世界上最强大的金融机构。联邦储备系统由美国国会于1913年创立，旨在提供稳定的货币体系，由一个中央政府机构和12个地区联邦储备银行组成。",
	"FixedExchangeRate": "固定汇率",
	"FixedExchangeRateText": "一种汇率制度，™其中货币的价值由货币当局根据一种或多种货币的价值设定。",
	"FloatingExchangeRate": "浮动汇率",
	"FloatingExchangeRateText": "一种汇率制度，其中货币™的价值由外汇市场根据相对于其他货币的需求和供应固定。",
	"Flatsquare": "扁平/方形",
	"FlatsquareText": "经销商行话用于描述已经完全颠倒的头寸。例如，您买入了100，000美元，然后卖出了100，000美元，因此创建了一个持平头寸。",
	"Foreign_Exchange": "外汇",
	"Foreign_ExchangeText": "外汇是将一种货币换成另一种货币。它是交易者买卖货币的全球在线网络。它没有物理位置，每天24小时运行。",
	"Forward": "向前",
	"ForwardText": "预先指定的利率，根据所涉及的两种货币之间的利率差异，在特定的未来时间锁定价格。",
	"Forward_Contracts": "远期合约",
	"Forward_ContractsText": "双方在预先指定的到期日以指定价格购买或出售资产的协议。双方都有义务履行协议的结束。",
	"ForwardRates": "远期利率（掉期）",
	"ForwardRatesText": "远期利率是固定期间内2种货币的利息差额的现金价格，只要给出每种货币的固定利率和当前的即期利率，就可以很容易地计算出来。",
	"Forward_Trading": "远期交易",
	"Forward_TradingText": "远期交易是在给定时间进行与现货交易相反的交易。交易者经常将他们的交易向前交换，范围从一周到几个月不等。即使远期合约发生在未来的某个日期，该头寸仍然可以随时平仓。然后，该头寸的平仓部分被交换到相同的未来起息日。",
	"Forwardpoints": "远期积分",
	"ForwardpointsText": "只需从当前汇率中增加或减去的点数即可计算远期价格。",
	"Fundamental_Analysis": "基本面分析",
	"Fundamental_AnalysisText": "分析可能影响未来价格的因素的方法。这种形式的分析基于外部事件和影响以及行业趋势，技术交易者从图表和模式中获取信息。",
	"FuturesContract": "期货交易合同",
	"FuturesContractText": "双方之间在未来预定日期以预定价格进行交易的法律协议。期货在交易所进行交易，可用于获得各种资产的风险敞口。",
	"Gearing": "传动",
	"GearingText": "当交易者以部分债务或保证金进行交易时。",
	"GroupofFive": "五国集团（G5）",
	"GroupofFiveText": "五个主要工业国家 - 法国，日本，英国，德国和美国，不时开会讨论共同的经济问题。",
	"GroupofSeven": "七国集团 （7）",
	"GroupofSevenText": "\"七人小组\"是7个主要的非共产主义工业化国家，包括法国，德国，英国，德国和美国以及加拿大和意大利。自俄罗斯加入以来，他们现在被称为G8。",
	"GroupofTen": "十国集团（G10）",
	"GroupofTenText": "也被称为\"巴黎俱乐部\"，由加拿大，比利时，法国，德国，意大利，瑞典，日本，英国，美国和荷兰组成。它成立于1962年，旨在向国际货币基金组织提供资金，并协助国际收支困难的成员国。",
	"GoldilocksEconomy": "金发女郎经济",
	"GoldilocksEconomyText": "该术语用于描述不太热或不太冷的经济，并以名义通货膨胀率维持适度增长，从而允许市场友好的货币政策。",
	"GoodtilCancel": "取消前有效(GTC) 订单",
	"GoodtilCancelText": "在取消或完成之前有效的订单，无论下订单的时间长短。",
	"HEDGING": "对冲",
	"HEDGINGText": "一种风险管理策略，投资者通过采取两种™相反的头寸来保护自己免受不利的价格变动的影响，从而降低风险。在货币交易的背景下，它将保护人们免受外汇汇率波动的影响。",
	"INFLATION": "通货膨胀",
	"INFLATIONText": "消费品一般价格水平持续上涨，侵蚀了购买力。",
	"INITIALMARGIN": "初始保证金",
	"INITIALMARGINText": "进入头寸所需的抵押品的初始存款，作为对未来业绩的保证。",
	"INTERBANKRATES": "银行同业拆借利率",
	"INTERBANKRATESText": "大型国际银行引用其他大型国际银行的外汇汇率。",
	"LEADINGINDICATORS": "领先指标",
	"LEADINGINDICATORSText": "考虑经济变量来预测未来的经济活动。",
	"LEVERAGEs": "杠杆作用",
	"LEVERAGEsText": "杠杆由经纪人提供，以最大限度地提高交易者™的购买力。从交易者的角度来看，它可以被描述为\"借入资本\"，™并增加了您的潜在回报，因为您可以使用这些资金进行交易的交易量比您有限的资本大得多。它以 1：100、1：300 等比率表示。因此，在1：100的杠杆下，™交易者的购买力被放大了100倍。<strong>免責聲明：</strong>杠杆既放大了可能的回报，也放大了损失。",
	"LIBOR": "伦敦银行同业拆借利率",
	"LIBORText": "伦敦银行同业拆借利率。这是全球主要银行相互放贷的基准利率。",
	"LIMITORDER": "限价订单",
	"LIMITORDERText": "以指定价格或更好的价格执行交易的订单。例如，如果欧元/美元的当前价格为1.08502/1.08522，则买入欧元的限价订单的价格将低于市场价格1.0820。",
	"LINECHARTS": "折线图",
	"LINECHARTSText": "连接选定时间段内单个价格（所有收盘价）的价格图表。",
	"LIQUIDITYs": "流动性",
	"LIQUIDITYsText": "货币对在市场上™买卖的能力，而不会导致其汇率发生重大变化。",
	"LIQUIDATION": "清算",
	"LIQUIDATIONText": "通过执行抵消交易平仓现有头寸。",
	"LONGPOSITION": "多头仓位",
	"LONGPOSITIONText": "如果一个头寸在市场价格上涨时升值，™则称为\"多头\"。当一个人买入一个货币对时，他们的头寸是多头的。",
	"Margins": "保证金",
	"MarginText": "保证金是保持保证金头寸未平仓所需的金额。这是您的头寸的全部价值与经纪人/杠杆提供商借给您的资金之间的差额。",
	"MarginDeposit": "保证金存款",
	"MarginDepositText": "保证金存款是交易者为开立杠杆交易头寸而需要存入的初始金额。它也可以被称为初始保证金，存款或简单地存款。",
	"MarginCall": "追加保证金",
	"MarginCallText": "追加保证金可以被描述为您的经纪商发出的警报/请求/致电，以通知您您的维持保证金已降至最低水平以下，并且您的头寸有被清算的风险。因此，在这种情况下，经纪人要求客户充值他们的账户以保持现有的未平仓头寸。",
	"MarketMaker": "做市商",
	"MarketMakerText": "保持坚定的买入价和卖出价并准备为任何金融工具制作双边市场的交易商。",
	"MarketRisk": "市场风险",
	"MarketRiskText": "暴露于市场价格的变化。",
	"Marktomarket": "按市值计价",
	"MarktomarketText": "根据当前市场价格调整/评估所有未平仓头寸。",
	"Maturity": "成熟",
	"MaturityText": "金融工具的结算或到期日。",
	"NarrowMarket": "窄幅市场",
	"NarrowMarketText": "交易所市场的另一个特点是市场稀薄，买家和卖家数量少，价格往往波动。",
	"Offer_s": "提供",
	"OfferText": "与要价相同，即经销商愿意出售的价格。",
	"Offsettingtransaction": "抵消交易",
	"OffsettingtransactionText": "抵消可能意味着关闭头寸以取消或抵消未平仓头寸的部分或全部市场风险。",
	"OneCancelsOrder": "一个取消另一个订单 （OCO）",
	"OneCancelsOrderText": "当您下达止损单和限价单时，如果其中一个被执行，则另一个订单将自动取消。",
	"Openorder": "未结订单",
	"OpenorderText": "没有特定到期日的订单，在达到特定市场价格时执行。它们通常与 GTC 订单相关联。",
	"Open_position": "未平仓头寸",
	"OpenPositionText": "仍处于活动状态且尚未平仓或反转的头寸。",
	"OvertheCounter": "场外交易 （OTC）",
	"OvertheCounterText": "场外交易适用于未在任何中央交易所上市的公司的证券，因此此类证券的买卖是在场外进行的，即通过直接与买卖双方谈判的私人经纪人和交易商。",
	"Overnight": "过夜",
	"OvernightText": "一个交易/头寸，一直保持开放，直到下一个工作日。",
	"Pip_s": "点数",
	"PipText": "报价外汇价格的最小变化量。大多数主要货币将点数定义为小数点后第四位，因此一个点的变化相当于0.0001，但日元除外，其中点是小数点后的第二位数字。",
	"PoliticalRisk": "政治风险",
	"PoliticalRiskText": "由于政府政策的变化或不稳定，对投资者的™头寸/回报产生不利影响。",
	"PointFigureCharts": "点数图",
	"PointFigureChartsText": "点数图表不™考虑时间，完全关注资产的价格变动和趋势。",
	"Position_s": "位置",
	"PositionText": "头寸是当前活跃且能够产生亏损/收益的交易的财务术语，称为未平仓头寸或最近关闭的交易，称为平仓头寸。",
	"Premium": "奖赏",
	"PremiumText": "期货或远期价格超过现货价格的金额。",
	"PriceTransparency": "价格透明度",
	"PriceTransparencyText": "阐明每个市场参与者都可以平等访问的报价",
	"Quote_s": "报价",
	"QuoteText": "资产上次交易或当前可以买入或卖出的价格，仅用于其他信息。",
	"RATE_s": "率",
	"RATEText": "一种货币相对于另一种货币的价格，其值相对于每种货币随时间而变化。",
	"RESISTANCE_s": "阻力",
	"RESISTANCEText": "一个常用的技术分析术语，表示货币无法交叉的特定价格水平。这样的价格起到了上限的作用。",
	"REVALUATION": "再评价",
	"REVALUATIONText": "与贬值相反，重估是由于央行干预而对一个国家™官方汇率的上调。",
	"REVALUATIONRATES": "重估率",
	"REVALUATIONRATESText": "这些是交易者用作基准值的市场汇率，用于评估当天或整体是否实现了利润/损失。通常重估率是前一个交易日的收盘价。",
	"RISK_s": "风险",
	"RISKText": "潜在的负面结果，例如表现不佳，未能实现交易/投资目标或亏损或不利变化。",
	"RISKCAPITAL": "风险资本",
	"RISKCAPITALText": "个人能够投资的金额，其损失不应导致其生活方式的重大变化。",
	"RISK_MANAGEMENT": "风险管理",
	"RISKMANAGEMENTText": "用于减轻和/或控制交易和投资固有风险的所有技术和策略，例如使用止损，对冲，多样化等。",
	"ROLLOVER": "展期",
	"ROLLOVERText": "它是在今天的™起息日同时平仓，并在第二天的™起息日以反映两种货币之间利率差异的价格开立同一头寸。",
	"ROLLOVERRATE": "展期率",
	"ROLLOVERRATEText": "持有头寸而支付或隔夜赚取的利息，取决于既定的保证金和市场头寸。",
	"SETTLEMENT": "结算",
	"SETTLEMENTText": "将金融工具的所有权转让给买方。货币交易的结算可能涉及也可能不涉及一种货币与另一种货币的实际实物交换。",
	"SHORTPOSITION": "空头头寸",
	"SHORTPOSITIONText": "当交易者首先卖出证券，打算在价格下跌时回购时，头寸被称为空头。当他认为价格可能在不久的将来下跌时，就会采取这种立场。",
	"SLIPPAGE": "滑点",
	"SLIPPAGEText": "当买卖价差在请求订单的时间到订单执行的时间之间发生变化时，就会发生滑点。这通常发生在高波动性时期，并发生在所有市场，如股票，债券，货币和期货。",
	"SPOTNEXT": "即期/次日",
	"SPOTNEXTText": "也称为\"下一个工作日\"，它表示在即期日期后一天交付购买的货币。它们是短期掉期，其中货币再推出一天，即在现货之后。",
	"SPOTPRICE": "现货价格",
	"SPOTPRICEText": "金融工具的当前市场价格。",
	"SPOTRATE": "即期（汇率）",
	"SPOTRATEText": "货币可以买入或卖出的当前汇率。它是零售市场报价的利率，没有调整利率差异。",
	"SPOTTRADE": "现货交易",
	"SPOTTRADEText": "它是指在指定的现货日期购买和销售金融产品以进行即时交付。也称为现货交易，通常以电子方式结算。",
	"Spread_s": "点差",
	"SpreadText": "交易中的点差是指货币对的买入价和卖出价之间的范围/差额。",
	"Sterling": "英镑",
	"SterlingText": "英镑的术语。",
	"StopLossOrder": "止损订单",
	"StopLossOrderText": "一种订单类型，用于在价格达到或低于指定价格时卖出货币。这是用来限制损失的，通常是当交易者无法主动监控价格时。",
	"StochasticOscillator": "随机振荡指标",
	"StochasticOscillatorText": "术语随机指标是指当前价格相对于其价格范围在一段时间内的点。随机振荡器是一种流行的技术分析指标，它指出在向上交易市场中，价格往往会接近高点，反之亦然。",
	"SupportLevels": "支持级别",
	"SupportLevelsTexts": "该术语表示货币无法穿越的特定价格水平。当下跌价格停止，改变方向并开始上涨时，就会出现支撑。支撑位通常被视为支撑或支撑价格的\"地板\"。",
	"Swap_s": "掉期",
	"SwapText": "掉期是一种衍生品合约，双方通过该合约交换由两种不同金融工具产生的现金流或负债。",
	"Swift": "银行代码",
	"SwiftText": "全球银行间金融电信协会。它提供了一个专用的计算机网络，使世界各地的金融机构能够在安全，标准化和可靠的环境中支持资金转移消息。",
	"TECHNICALANALYSIS": "技术分析",
	"TECHNICALANALYSISText": "它涉及使用各种技术指标，并通过研究图表，交易量，趋势，模式，移动平均线和各种其他技术指标来分析市场行为，目的是预测价格。",
	"TICK_s": "价格波动单位",
	"TICKText": "价格变动代表任何即将到来的报价，上涨或下跌。",
	"TICKER": "代码",
	"TICKERText": "它以表格或图表的格式显示货币的当前或最近历史。",
	"TOMORROWNEXT": "隔夜掉期",
	"TOMORROWNEXTText": "它是同时买入和卖出货币以在第二天交货。",
	"TRADING_s": "交易",
	"TRADINGText": "买卖、交换股票、债券或货币等的行为。",
	"TRANSACTIONCOST": "交易成本",
	"TRANSACTIONCOSTText": "买卖金融工具的成本。",
	"TRANSACTIONDATE": "交易日期",
	"TRANSACTIONDATEText": "交易发生的日期。",
	"TREND_s": "趋势",
	"TRENDText": "趋势只是价格向某个方向移动的趋势，向上/向下/反向/横盘。它们通常分为三类 - 主要，中期和短期趋势。",
	"TRENDLINE": "趋势线",
	"TRENDLINEText": "这是一个非常常用的技术指标，用于揭示趋势。趋势线将两个或多个低点或更多高点与预测到未来的线连接起来。它是使用\"至少平方法\"计算的，也称为线性回归。",
	"TURNOVER": "营业额",
	"TURNOVERText": "它是给定时间段内所有已执行交易的总货币价值。",
	"TWOWAYPRICE": "双向报价",
	"TWOWAYPRICEText": "双向报价表示交易日的证券的当前买入价和当前卖出价。",
	"UPTICK": "上升",
	"UPTICKText": "当证券™的价格相对于最后一个价格变动上涨时，就会发生上涨。这是价格高于前一个报价的新报价。",
	"UPTICKRULE": "上升规则",
	"UPTICKRULEText": "美国的交易限制规定，只有在上涨时才允许卖空。根据规则，除非卖空前的最后一笔交易的价格低于执行卖空的价格，否则证券不得卖空。",
	"USPRIMERATE": "美国最优惠利率",
	"USPRIMERATEText": "美国银行向其主要企业客户放贷的利率。",
	"VALUEDATE": "起息日",
	"VALUEDATEText": "对应方同意清偿各自债务的日期。对于现货货币交易，起息日通常为两个工作日。也称为到期日，它是交易结算的日期。",
	"VARIATIONMARGIN": "变动保证金",
	"VARIATIONMARGINText": "基金交易者必须持有其账户以保持杠杆交易开放。 该术语通常是指由于不利的价格变动而必须存入的额外资金。",
	"VOLATILITYVOL": "波动率（挥发量）",
	"VOLATILITYVOLText": "它的特点是快速和随机的价格变动，是一个术语，用于指经常提供贸易机会的活跃市场。",
	"VOLUME_s": "卷",
	"VOLUMEText": "在特定时期内交易的合约总数。",
	"WeakDollarStrongDollar": "弱势美元/强势美元",
	"WeakDollarStrongDollarText": "弱势和强势美元一词在外汇市场中用于描述美元对其他货币的相对价值和强势。当需要更多的美元来购买一个单位的另一种货币时，美元被认为是疲软的，而当需要很少的美元来购买另一种货币的一个单位时，美元是强势的。",
	"Whipsaw": "锯齿状态",
	"WhipsawText": "当价格快速增长后急剧下跌（反之亦然）时，会出现极端波动的情况。",
	"Yard": "十亿",
	"YardText": "外汇期限为十亿单位",
	"YIELD": "收益率",
	"YIELDText": "投资所得收入。",
	"steps_heading1": "个人信息",
	"steps_heading2": "声明",
	"steps_heading3": "上传个人文档",
	"step1_personalinfo": "个人信息",
	"step1_fname": "名字",
	"step1_age_error": "年龄必须介于 18 到 80 之间",
	"step1_lname": "姓",
	"step1_dob": "出生日期",
	"step1_dobrequired": "出生日期是必需的",
	"step1_below18": "您的年龄未满 18 岁",
	"step1_addinfo": "地址信息",
	"step1_city": "城市",
	"step1_postalcode": "邮政编码",
	"step1_countryRes": "居住国家",
	"step1_otherinfo": "其他信息",
	"step1_addInfo": "附加信息",
	"step1_phno": "电话号码",
	"step1_phnoRequired": "电话号码为必填项",
	"step1_correctno": "请输入正确的电话号码",
	"step1_prefcurrency": "选择首选钱包货币",
	"step1_pep": "您是政治公众人物（PEP）吗？",
	"step1_usPerson": "您是美国人吗？",
	"step1_Next": "下一个",
	"step1_firstmember": "第一个会员信息",
	"step1_member1dob": "会员 1 出生日期为必填项",
	"step1_member1age": "会员 1 年龄是 18",
	"step1_secondmember": "第二会员信息",
	"step1_menber2dobreq": "会员2 出生日期为必填项",
	"step1_member2age": "会员 2 年龄是 18 岁以下",
	"step1_adressinfo": "地址信息",
	"step1_companyinfo": "公司介绍",
	"step1_companyname": "公司名称",
	"step1_incopDate": "成立日期",
	"step1_incodateReq": "公司注册日期为必填项",
	"step1_futuredate": "未来日期不允许",
	"step1_authorperson": "授权人员信息",
	"step1_companyAdrsinfo": "公司地址信息",
	"step1_regAddone": "注册公司地址行 1",
	"step1_regAddtwo": "注册公司地址行 2",
	"step1_country": "国家",
	"step1_minimumph": "电话号码至少包含 8 个字符",
	"step1_maxphone": "电话号码不得超过 15 个字符",
	"step1_stepMsz2": "PEP是在任何国家被委托履行以下重要公共职能的自然人，以及他/她的直系亲属和已知与该人关系密切的人： <ul> <li>国家元首，政府首脑，部长和副部长或助理部长，</li> <li> 议会议员或类似立法机构的成员，</li>除特殊情况外<li>，各政党理事</li><li>机构成员、最高法院、宪法法院或其他高级司法机构成员，其决定不得进一步上诉，</li><li>审计法院或中央银行董事会成员、</li><li>大使、临时代办©和武装部队高级官员，</li> <li>政府企业或国有企业的行政、管理或监督机构</li><li>成员、董事、副董事和董事会成员或在国际组织中担任同等职务的人员、</li><li>市长</li> </ul>",
	"step1_stepMsz3": "美国人的定义（\"美国人\"）包括： <ul> <li> 美国公民或居民（包括双重国籍），</li> <li> 美国外国人（出于税收目的的居民）</li> <li> 在美国出生的人？ </li>  <li> 拥有当前美国邮寄或居住地址（包括美国邮政信箱或美国照管地址） </li> <li> 的人 拥有当前美国电话号码 </li> <li> 的人 有长期指示将资金转入在美国境内的帐户的人？</li> <li> 拥有当前有效授权书或签署授权给具有美国地址的人的人？</li></ul>",
	"step4_readaccept": "我已阅读，理解并接受",
	"step4_ClientAgreement": "客户协议",
	"step4_privacyplicy": "隐私策略",
	"step4_and": "和",
	"step4_riskDisclosr": "风险披露文件",
	"step4_termsAgreeRqd": "请同意这些条款",
	"step4_policytwo": "我同意根据隐私政策处理和存储我的个人数据，并同意Fxview就我帐户的重要信息与我联系",
	"step4_AfterCalling": "注意：点击后",
	"step4_saveContinue": "保存并继续",
	"step4_allInfoCorrect": "您将无法更改任何先前的步骤信息。确保所有信息正确无误！",
	"step5_browsersupport": "也许浏览器在网络摄像头方面遇到了一些技术问题",
	"step5_cameradenied": "相机权限被拒绝",
	"step5_scanqrcode": "改为扫描二维码",
	"step5_scanqrmobile": "使用手机摄像头或二维码应用程序扫描此二维码",
	"step5_keepageopen": "请在使用手机时保持此页面打开状态",
	"step5_continueBrowser": "继续使用浏览器",
	"step5_docSubsuccess": "您的文件已成功提交。在我们审核您的文件时，请耐心等待，高峰时段可能需要长达 24 小时或更长时间。",
	"step5_reviewstatus": "点击此处查看您的机票状态",
	"step5_identifyDoc": "身份证明文件",
	"step5_proofresidence": "居住证明文件",
	"step5_uploadphototext": "上传您的身份证明文件照片。请确保身份证件上的详细信息与您在个人信息表单中输入的信息一致。",
	"step5_uploadproof": "上传您的居住地址证明（以您的名义且不超过6个月）。请注意，我们不接受截图。",
	"step5_takephoto": "拍摄驾驶执照的照片并在此处上传",
	"step5_takegovernid": "拍摄政府签发的身份证件的照片并在此处上传",
	"step5_goodQuality": "质量好：",
	"step5_brightclear": "明亮清晰",
	"step5_note": "注意：",
	"step5_allcorner": "文档的所有角都可见，并且文档必须有效（未过期）",
	"step5_allcorner1": "必须出示您的全名，居住地址，签发机构和签发日期。文档的所有角落都清晰可见。",
	"step5_uploadfrontside": "请上传文档的正面",
	"step5_maximumfilesize": "最大文件大小可上传",
	"step5_maxfilesize": "可接受的最大文件大小不超过",
	"step5_uploadbackside": "上传文档背面",
	"step5_upload": "上传",
	"step5_idenfNumber": "请注明您的身份证明文件中的身份证号码。",
	"step5_uploadpassport": "拍摄护照照片并在此处上传",
	"step5_photolicense": "拍摄驾驶执照的照片并在此处上传",
	"step5_photogovernmentID": "拍摄政府签发的身份证件的照片并在此处上传",
	"step5_proofsixold": "拍摄您的证明或住所的照片（不超过6个月）：",
	"step5_bankstatement": "银行对账单、水电费账单（水、电、家庭互联网或固定电话）、税务文件、租赁协议（如果在过去6个月内签发）",
	"step5_uploadyourDoc": "上传您的文档",
	"step5_idnorequired": "ID 号为必填项。",
	"step5_filesizemax": "文件大小可以是最大",
	"step5_filesallowed": "只允许jpg，jpeg，png，pdf文件！",
	"step5_uploadbothside": "请上传文件的两面",
	"step5_verifydoc": "请上传您的文件以验证您的信息",
	"step5_continuemobile": "继续使用移动设备",
	"step5_recentphoto": "请上传您的近照",
	"step5_photoverif": "照片验证",
	"step5_legitimacy": "所有用户都必须上传验证照片。这只是我们用于确保用户合法性的众多技术和系统的一部分。",
	"step5_back": "返回",
	"step5_start": "使用网络摄像头",
	"step5_TakeSelfie": "自拍",
	"step5_webcamdont": "继续使用移动设备",
	"step5_captureimage": "捕获图像",
	"step5_cancel": "取消",
	"step5_filemax": "文件大小可以最大",
	"step5_choosefileupload": "选择要上传的文件",
	"step5_allowmaxsize": "我们允许的最大文件大小为",
	"step5_useWebcam": "使用网络摄像头",
	"soclTrade_zullutrade": "祖鲁贸易",
	"soclTrade_mql": "断续器",
	"zulu_trade": "ZuluTrade",
	"zulu_zulitradeinfo": "ZuluTrade是一个社交交易平台，您可以在其中关注全球交易者并复制交易，同时学习他们使用的策略。根据有关其交易风格和表现的完整信息，您可以轻松地选择您选择的交易者，一旦您关注他们，他们的交易将自动复制到您的帐户中。",
	"zulu_createAccount": "创建ZuluTrade帐户",
	"zulu_setupzulutrade": "如何设置ZuluTrade账户",
	"zulu_registeropen": "注册并开设一个Fxview ZuluTrade账户。",
	"zulu_findaccount": "为账户注资至少100美元，以接收ZuluTrade的登录凭据。",
	"zulu_logintozulu": "登录ZuluTrade网站并开始关注您选择的任何交易者。",
	"mampam_heading": "MAM/PAMM",
	"mampam_programenable": "fxview MAM / PAMM计划使经验丰富的交易者能够以专业的方式在单个主账户下管理多个子账户。",
	"mampam_knowmore": "了解更多",
	"mampam_becameinvestor": "如何成为投资者：",
	"mampam_clicktobecame": "点击成为投资者",
	"mampam_uniquepamid": "输入您的经理的唯一 ™PAMM ID 以查看他的个人资料。",
	"mampam_createinverstor": "创建您的投资者账户并与PAMM账户连接",
	"mampam_monitoracc": "通过PAMM投资者的™仪表板监控您的帐户",
	"mampam_connectmanager": "连接到管理器",
	"mampam_becomemanager": "如何成为经理：",
	"mampam_clickbecomemanager": "点击\"成为经理\"",
	"mampam_meetconditions": "满足接收您唯一 PAMM ID 所需条件",
	"mampam_manageaccount": "通过独家PAMM门户管理您的帐户",
	"mampam_becomeManager": "成为经理",


    //=========mam-pamm-account
	"mampamm_account_tab": 'Sub Account',
	"mampamm_account_account_type": 'Sub Account',
	"mampamm_account_heading": 'Account IB MAMM',
	"mampamm_account_description": 'The fxview MAM/PAMM program enables experienced traders to manage multiple sub accounts under a single master account, in a professional manner.',
	"mampamm_account_regsiter_heading": 'Steps to register IB MAMM Account',
	"mampamm_account_clicktobecame": 'Click on "Become an Investor"',
	"mampamm_account_uniquepamid": 'Enter your manager’s unique PAMM ID to view his profile.',
	"mampamm_account_createinverstor": 'Create your investor account and connect with the PAMM account',
	"mampamm_account_monitoracc": 'Monitor your account through PAMM investor’s dashboard',
	"mampamm_account_disclaimer": 'Disclaimer',
	"mampamm_account_username": 'Name',
	"mampamm_account_usernameRequired": 'The name is required',
	"mampamm_account_signature": 'Signature',
	"mampamm_account_signatureRequired": 'The signature is required',
	"mampamm_account_signatureMatchError": "Signature doesn't match with username",
	"mampamm_account_termscondition": 'I accept all the Terms and Conditions.',
	"mampamm_account_termsconditionRequired": 'Please agree terms and conditions in order to proceed',
	"mampamm_account_Proceed": 'Proceed to Create IB MAMM Account',
	"mampamm_account_Cancel": 'Cancel',
	"mampamm_account_Create": 'Create IB MAMM Account',
	"mampamm_account_List_Header": 'MY IB MAMM Account',
	"mampamm_account_Open_Ib_Mam_Pamm": 'Open IB MAMM Trading Account',
	"mampamm_account_Created_Successfully": 'Your account IB MAMM has been successfully created. Your credentials are:',
	"mampamm_account_Disclaimer_Approved_Successfully": 'Disclaimer approved successfully',
	"mampamm_account_No_Pdf_Found": 'No pdf found',

	
	"mql_heading": "MQL5",
	"mql_text": "MQL5 是世界上最大的复制交易社区之一，将新手交易者与经验丰富的交易者联系起来。用户可以从数千个免费和收费的经过验证的信号中进行选择，以提高他们的交易表现",
	"mql_createliveAcc": "创建真实账户",
	"mql_stepsRegister": "注册 MQL5 的步骤",
	"mql_stepone": "在其网站上注册一个MQL5账户",
	"mql_stepTwo": "打开Metatrader平台，然后转到工具>>选项，然后单击社区选项卡。登录 MQL5 账户，然后单击确定。",
	"mql_stepThree": "转到终端窗口中的信号选项卡，然后选择要跟踪的信号。",
	"unaut_under": "下",
	"unaut_Verification": "验证",
	"unaut_pendingVerificationMsz1": "我们的合规部门正在审核您的申请。您的文件可能需要3-4个工作日才能得到验证。验证文件后，您将收到一封电子邮件",
	"createzullu_Your": "你的",
	"createzullu_successcreate": "zuluTrade帐户已成功创建。您的登录信息包括：",
	"createzullu_accountBaseCurrency": "账户基础货币",
	"createzullu_tradenow": "立即交易",
	"createzullu_forWeb": "用于网络",
	"createzullu_open": "打开",
	"createzullu_tradingAcc": "交易账户",
	"createzullu_classic": "经典",
	"createzullu_USD": "美元",
	"createzullu_EUR": "欧元",
	"createzullu_GBP": "英镑",
	"createzullu_AUD": "澳元",
	"createzullu_ZAR": "南非兰特",
	"createzullu_leverageField": "杠杆是必填字段",
	"createzullu_accountPassword": "交易账户密码",
	"createzullu_passwordcontain": "您的密码必须至少包含 6 个字符和最多 15 个字符，并且至少包含 1 个特殊字符 （！@#$%^*/）",
	"createzullu_createAccount": "创建账户",
	"demoacc_demomsg": "模拟账户已成功创建。您的凭据包括：",
	"demoacc_MT4": "Meta Trader 4",
	"demoacc_MT5": "Meta Trader 5",
	"demoacc_passwordMust": "您的密码必须至少包含 6 个字符，最多 24 个字符，并且至少包含 1 个特殊字符 （！@#$%^*/）",
	"liveacc_accounthas": "真实账户已被",
	"liveacc_successfully": "成功",
	"liveacc_credentialsare": "创建。您的凭据包括：",
	"wit_Wallet_from_wallet": "从钱包",
	"depMsz11": "不是正确的 Skrill 帐户？请",
	"wit_Wallet_Back": "返回钱包",
	"wit_Wallet_No": "没有钱包",
	"wit_withdrawal": "提款",
	"wit_freeMargin": "可用保证金",
	"wit_withdrawalMsz1": "很抱歉，您还没有资格提款。存款和交易可以帮助您获得资格！",
	"wit_PrincipalWithAmount": "本金提款金额",
	"wit_AccNumber": "账户号码：",
	"wit_skrillId": "Skrill ID：",
	"wit_netId": "Neteller ID：",
	"wit_creditCardNumber": "信用卡号码",
	"wit_expiryDate": "有效期",
	"wit_allowOption": "请从上述允许的选项中进行选择",
	"wit_WithdrawalMethodReq": "提款方式为必填项",
	"wit_EnterWithdrawal": "输入提款",
	"wit_requestWithdrawal": "您可以在获得批准 24 小时后申请从新批准的付款方式中提款",
	"wit_withdrawalMsz2": "我们已收到您的提款请求，并将相应地更新您",
	"wit_withCont1": "Fxview不收取提款费。但是，请注意，支付处理商/金融中介机构可能会收取手续费。",
	"wit_withCont2": "由于第三方交易限制，资金只能退回到与您的Fxview交易账户同名的银行账户。此外，资金只会退回到收到资金的同一银行账户。",
	"wit_withCont3": "您可以提取到卡中的总金额不能超过存入卡的总金额。超过此级别的金额可以提取到您的银行帐户，Neteller或Skrill",
	"withdraw_backWithdraw": "返回提款",
	"withdrawList": "提款清单",
	"withdrawList_all": "全部",
	"withdrawList_pending": "待定",
	"withdrawList_processed": "处理",
	"withdrawList_rejected": "拒绝",
	"withdrawList_created": "日期",
	"withdrawList_accountId": "账户号码/钱包号码",
	"withdrawList_amount": "数量",
	"withdrawList_currency": "货币",
	"withdrawList_withdrawalType": "提款类型",
	"withdrawList_method": "方法",
	"withdrawList_withdrawalStatus": "状态",
	"withdrawList_detail": "详情",
	"withdrawList_viewTicket": "查看单据",
	"Wallet_Wallet": "钱包",
	"Wallet_Loyalty_Points": "忠诚积分",
	"Wal_detail_Add_New": "添加新的钱包货币",
	"Wal_detail_Wallet_ID": "钱包编号",
	"Wal_detail_Deposit": "存款",
	"Wal_detail_Withdraw": "取款",
	"Wal_detail_Transfer": "转账",
	"Wal_detail_curr_required": "货币字段为必填项",
	"Wal_detail_Submit": "提交",
	"Wal_detail_Trans_History": "交易记录",
	"Wal_detail_Date": "日期",
	"Wal_detail_Time": "时间",
	"Wal_detail_Type": "类型",
	"Wal_detail_From": "从",
	"Wal_detail_To": "到",
	"Wal_detail_Amount": "金额",
	"Wal_detail_Status": "状态",
	"Wal_detail_availAmount": "可用金额：",
	"acc_fund_Deposit": "存款",
	"acc_fund_Withdrawal": "提款",
	"chang_wal_curr_Internal_Transf": "钱包内部转账",
	"chang_wal_curr_Transf_Wall_amount": "转账钱包金额",
	"chang_wal_curr_Back": "返回电子钱包",
	"loyalP_Reward_Points": "忠诚奖励积分",
	"loyalP_Know_More": "了解更多",
	"loyalP_Trans_Wallet": "转账到钱包",
	"loyalP_Transfer": "转账",
	"loyalP_transf_TotalP": "总忠诚度积分",
	"loyalP_transf_Amou_Avail": "可用金额",
	"loyalP_transf_Enter_p_transfe": "输入积分转账",
	"loyalP_transf_Cancel": "取消",
	"loyalP_transf_Transfer": "转帐",
	"loyalP_transf_Back": "返回电子钱包",
	"loyalP_transToAcc": "转账至钱包ID",
	"loyalP_fieldReq": "此段为必填项",
	"loyalP_intTransMsz2": "请点击链接确认您的内部转账",
	"loyalP_intTransMsz3": "传输已成功完成",
	"loyalP_fromTradId": "从交易 ID",
	"loyalP_toTradId": "转至交易编号",
	"loyalP_transferAmount": "转账金额",
	"loyal_card_det_You_are_a": "您是",
	"loyal_card_det_member": "成员",
	"loyal_card_det_Points": "点",
	"loyal_card_det_Last_Credit_On": "最后信用额度",
	"loyal_card_det_Earn": "赚",
	"loyal_card_det_more_points_to_jump_to": "更多积分跳转到",
	"loyal_card_det_gain_add_benefi": "获得额外福利",
	"loyal_List_Trans_History": "交易记录",
	"loyal_List_Date": "日期",
	"loyal_List_Activity": "活动",
	"loyal_List_Volume": "交易量",
	"loyal_List_Points": "点",
	"loyal_List_Cr_Db": "Cr/Db",
	"loyal_ver_back": "返回电子钱包",
	"redeamP_your_points": "兑换您的忠诚积分",
	"redeamP_Points": "点",
	"redeamP_Redeem": "赎回",
	"redeamP_Red_Points": "兑换积分",
	"redeamP_Now": "立即重做",
	"redeamP_walletpoints": "请按照以下详细信息兑换钱包<br>积分：",
	"redeamP_pointdesc": "<br> point_desc ：",
	"tool_overview": "概述",
	"tool_autochartistScan": "自动图表扫描仪",
	"tool_autochartistWeb": "自动图表网站",
	"tool_Vpsheading": "虚拟专用服务器",
	"tool_ecoCalendar": "财经日历",
	"tool_tradingToolbox": "交易者的工具箱",
	"tool_Calculator": "计算器",
	"tool_tradingHOur": "交易时间",
	"tool_Signal": "信号",
	"autoScan_knoMore": "了解更多",
	"autoScan_DownLive": "下载真实账户",
	"autoScan_HowInstall": "如何安装自动图表",
	"autoScan_usrGuide": "用户指南",
	"autoScan_goTool": "在平台中，转到工具>选项>专家顾问以允许DLL导入，然后单击确定。",
	"toolVps_sureImp": "是否确实要实现此操作？",
	"toolVps_confirm": "确认",
	"toolVps_cancel": "取消",
	"toolVps_Shut_Down": "关机",
	"toolVps_Restart": "重新启动",
	"toolVps_Reboot": "重新启动",
	"toolVps_Change_Pass": "更改密码",
	"toolVps_VieDet": "查看详情",
	"toolVps_UpdAcc": "更新帐户",
	"toolVps_Unsubscribe": "取消订阅",
	"toolVps_vpsList": "虚拟专用<span>服务器</span>列表",
	"toolVps_createVps": "创建虚拟专用网络",
	"toolVps_SubList": "订阅列表",
	"toolVps_accWalt": "账户/钱包",
	"toolVps_Priodicity": "周期性",
	"toolVps_Price": "价格",
	"toolVps_strtDate": "开始日期",
	"toolVps_endDate": "结束日期",
	"toolVps_Action": "行动",
	"toolVps_vps": "虚拟专用<span>服务器</span>",
	"toolVps_vpsTilte": "与我们一起享受无与伦比的交易体验，确保您的交易稳定。无需再担心延迟或处理系统上的多个软件。使用我们的免费VPS，为您的交易获得闪电般的快速响应，并在我们的平台上享受令人印象深刻的速度。",
	"toolVps_redLate": "减少延迟",
	"toolVps_freeOn5000": "存款$5，000或以上即可免费",
	"toolVps_remoteAccess": "远程访问",
	"toolVpsstab_Env": "稳定的环境",
	"toolVps_back_vpsList": "返回VPS列表",
	"toolVps_tc": "受条款及细则约束",
	"toolVps_Plan": "计划",
	"toolVps_Status": "状态",
	"toolVps_type": "类型",
	"toolVps_nextpayment": "下次付款",
	"toolVps_passWordMustContain12": "您的密码必须至少包含 12 个字符，并且至少包含 1 个数字、1 个大写字符和 1 个特殊字符 （！@#$%^&*/）",
	"toolVps_verifySubscribe": "您的更新交易账户请求已成功处理",
	"toolVps_back_subList": "返回订阅列表",
	"toolVps_reqProcessing": "请求处理...",
	"toolVps_reqVerify": "请求验证",
	"toolVps_reqFailed": "请求失败",
	"VpsSub_1_Record": "您只有一条记录。在尝试更改订阅帐户之前，请至少再创建一个交易账户或钱包。",
	"VpsSub_liveAcc": "真实账户",
	"VpsSub_Wallet": "钱包",
	"VpsSub_ChangeTradAcc": "更改认购交易账户",
	"VpsSub_back_subLis": "返回订阅列表",
	"VpsSub_Submit": "提交",
	"VpsSub_received_request": "我们已收到您的更改交易账户请求，并将相应地更新您",
	"VpsSub_withdrawalAuthMessage": "请通过单击我们发送到您的注册电子邮件ID的链接来验证提款请求",
	"VpsSub_noTradingAccFound": "未找到真实交易账户！",
	"VpsUnSub_1_record": "您只有一条记录。在尝试更改订阅帐户之前，请至少再创建一个交易账户或钱包。",
	"VpsUnSub_liveAcc": "真实账户",
	"VpsUnSub_Wallet": "钱包",
	"VpsUnSub_sureUnsub": "您确定要取消订阅吗",
	"VpsUnSub_plan_": "计划？",
	"VpsUnSub_confirm": "确认",
	"VpsUnSub_Cancel": "取消",
	"VpsUnSub_received_request": "我们已收到您的更改交易账户请求，并将相应地更新您",
	"VpsUnSub_back_subList": "返回订阅列表",
	"VpsUnSubVer_successfully": "您的取消订阅计划请求已成功处理",
	"VpsUnSubVer_back_subList": "返回订阅列表",
	"marktTrdHour_title": "市场交易时间",
	"marktTrdHour_txt": "我们的服务器时间是美国夏令时 （DST） 的 GMT+3 和美国非夏令时 （Non-DST） 的 GMT+2。",
	"marktTrdHour_table_below": "下表列出了根据我们的服务器时间，各种工具和资产类别的开盘和收盘时间。",
	"marktTrdHour_Forex": "外汇",
	"marktTrdHour_Indices": "指标",
	"marktTrdHour_Commodities": "商品",
	"marktTrdHour_Open": "打开",
	"marktTrdHour_Close": "关闭",
	"marktTrdHour_Break": "休息",
	"trdMarktPlac_title": "交易者<span>市场</span>",
	"trdMarktPlac_txt": "浏览我们的市场，访问由一些世界上最好的交易者创建的策略，或设计您自己的策略，我们将帮助您建立它。 我们的市场是一站式商店，将您的交易提升到一个新的水平。",
	"trdMarktPlac_Automate": "自动化您的<span>交易</span>，以充分利用市场",
	"trdMarktPlac_Customise": "定制您的交易",
	"trdMarktPlac_Customise_Txt": "通过与将为您构建系统的开发人员联系，定义您的需求并使您的系统栩栩如生",
	"trdMarktPlac_Risk_manag": "风险管理",
	"trdMarktPlac_Risk_manag_txt": "根据信号提供商的经验、最佳和最差交易、风险状况等审查信号提供商的表现",
	"trdMarktPlac_Browse_library": "浏览我们的资料库",
	"trdMarktPlac_Browse_libraryTxt": "浏览我们丰富的MT4，MT5和ActTrader的EA和指标库，找到适合您需求的",
	"trdMarktPlac_Categories": "类别",
	"trdMarktPlac_All": "全部",
	"trdMarktPlac_Expert": "专家",
	"trdMarktPlac_Advisors": "顾问",
	"trdMarktPlac_Indicators": "指标",
	"trdMarktPlac_ActTrader": "交易行为",
	"trdMarktPlac_Popular": "流行",
	"trdMarktPlac_New": "新增功能",
	"trdMarktPlac_Free": "自由",
	"trdMarktPlac_Paid": "支付",
	"trdMarktPlac_Long_Str": "长期战略",
	"trdMarktPlac_2frame": "两帧",
	"trdMarktPlac_StratCon2": "策略由两个不同的图表历史组成：",
	"trdMarktPlac_Details": "详情",
	"trdMarktPlac_Add_List": "添加到列表",
	"trdMarktPlac_Hammer_Ass": "锤行线助手",
	"trdMarktPlac_Strat_trad_assis": "此策略（交易助手）将在锤子形成时向您发出警告，并且",
	"trdMarktPlac_Pos_Mgmt": "职位管理",
	"trdMarktPlac_Lot_Cal": "手数计算器",
	"trdMarktPlac_Lot_Cal_txt": "手数计算器 - 是一个外汇工具，可以让你计算...",
	"trdMarktPlac_Short_Strat": "短期策略",
	"trdMarktPlac_Reg_Stra": "回归策略",
	"trdMarktPlac_Reg_StraTxt": "策略在当前蜡烛的低值 = 顶部皮带时打开买入头寸。",
	"trdMarktPlac_NoData": "暂无数据",
	"ecoCalendar": "财经日历",
	"ecoCal_Title_Txt": "跟踪影响外汇、商品和指数的重要经济事件和新闻稿。",
	"ecoCal_Up_next": "下一个",
	"ecoCal_Country": "国家",
	"ecoCal_Select_All": "全选",
	"ecoCal_Clear": "清楚",
	"ecoCal_My_Filter": "我的过滤器",
	"ecoCal_Default": "违约",
	"ecoCal_Impact": "冲击",
	"ecoCal_All": "全部",
	"ecoCal_Medium": "中等",
	"ecoCal_High": "高",
	"ecoCal_Save_filter": "我的过滤器中的保存设置",
	"ecoCal_Apply_Filter": "应用过滤器",
	"ecoCal_Time": "时间",
	"ecoCal_TimeZ_Settings": "时区设置",
	"ecoCal_TimeZ": "时区",
	"ecoCal_Select_TimeZ": "选择时区",
	"ecoCal_TimeF": "时间格式",
	"ecoCal_Set_timeZ_Auto": "自动设置我的时区",
	"ecoCal_Save_Sett": "保存设置",
	"ecoCal_Cancel": "取消",
	"ecoCal_noRecord": "暂无记录",
	"ecoCal_Event": "事件",
	"ecoCal_Actual": "实际",
	"ecoCal_Forecast": "预测",
	"ecoCal_Previous": "以前",
	"tools_Trad_Tools": "交易工具",
	"tools_Trad_Tools_Txt": "使用我们强大的交易工具做出明智和及时的投资决策，帮助您识别潜在机会并建立更强大的交易策略",
	"tools_Auto_Scanner": "自动图表扫描仪",
	"tools_Auto_Scanner_txt": "再也不会错过任何交易机会。",
	"tools_VPS": "虚拟专用服务器",
	"tools_VPS_txt": "享受免费的基本VPS或从订阅中选择。",
	"tools_Eco_Calendar": "财经日历",
	"tools_Eco_Calendar_txt": "随时了解重要的经济事件。",
	"tools_Trad_Toolbox": "交易者的工具箱",
	"tools_Trad_Toolbox_txt": "一系列优质的交易和分析工具。",
	"tools_Calculators": "计算器",
	"tools_Calculators_txt": "计算点值，保证金，掉期等。",
	"tools_TradeMarket": "交易者市场",
	"tools_TradeMarket_txt": "找到您理想的 EA 或指标，或拥有.",
	"tools_Trad_Hours": "交易时间",
	"tools_Trad_Hours_txt": "快速查看市场何时开放。",
	"tools_Auto_Idea": "自动图表专家理念",
	"tools_Auto_Idea_txt": "再也不会错过任何交易机会。",
	"tools_readmore": "阅读更多",
	"tools_downloa": "下载",
	"MT4Demo": "MT4 演示",
	"MT5Demo": "MT5 演示",
	"toolor": "或",
	"toolknowMore": "了解更多",
	"chEn_entity": "实体",
	"chEn_global": "Fxview Global",
	"chEn_europe": "Fxview Europe",
	"chEn_redirectmsg1": "根据您的居住国选择，您将被重定向到在塞浦路斯注册的Charlgate Ltd.的网站。Charlgate Ltd.属于欧洲监管框架，属于金融工具市场指令II（MiFID II）等范围。此外，还规定了投资者赔偿计划。",
	"chEn_redirectmsg2": "",
	"chEn_continue": "继续",
	"chEn_takeback": "撤销操作",
	"adchart_create": "创建",
	"adchart_save": "保存",
	"adchart_chart": "图表",
	"adchart_Studies": "研究",
	"adchart_failedchart": "无法加载图表",
	"adchart_kindlyrefresh": "请刷新",
	"chart_loadchartfail": "无法加载图表 请刷新！",
	"filter_Selecttimezone": "选择时区",
	"filter_Low": "低",
	"filter_medium": "中等",
	"filter_high": "高",
	"filter_submit": "提交",
	"head_Wallet": "钱包",
	"head_loyality": "忠诚积分",
	"head_createLiveAcc": "创建真实账户",
	"head_createDemoAcc": "创建模拟账户",
	"head_Notification": "通知",
	"head_seeAll": "查看全部",
	"head_noNewNotification": "无新通知",
	"head_verified": "验证",
	"head_deposit_enabled": "已啟用存款",
	"head_notVerified": "未验证",
	"head_profile": "资料",
	"head_changePassword": "更改密码",
	"successMsz4": "密码更改成功",
	"head_security": "安全",
	"head_referFriend": "推荐朋友",
	"head_logout": "登出",
	"leftnav_dashboard": "仪表板",
	"leftnav_wallet": "钱包",
	"leftnav_accfunding": "账户注资",
	"leftnav_manageAcc": "管理账户",
	"leftnav_Depositbonus": "存款奖金",
	"leftnav_socialTrade": "社交交易",
	"leftnav_tools": "工具",
	"leftnav_education": "教育与",
	"leftnav_resources": "资源",
	"leftnav_downloadplatform": "下载平台",
	"leftnav_support": "支持",
	"load_norecordfound": "未找到记录",
	"tradAcc_application": "请完成您的帐户申请并创建一个",
	"tradAcc_application1": "请完成您的账户申请以接收此功能",
	"tradAcc_trading": "交易",
	"tradAcc_live": "真实",
	"tradAcc_accountAccess": "帐户以访问此功能。",
	"tradAcc_resumeApplication": "简历申请",
	"tradAcc_checkappStatus": "您的申请正在审核中，请检查您的单据状态。",
	"tradAcc_ticket": "单据",
	"tradAcc_createliveAcc": "请创建一个真实账户来访问此功能",
	"tradAcc_liveDemoAcc": "请创建一个真实或模拟账户来访问此功能",
	"tradAcc_demoAcc": "模拟账户",
	"tradAcc_createWallet": "请创建一个钱包来访问此功能",
	"tradAcc_wallet": "钱包",
	"pagin_totalRecords": "记录总数",
	"acclist_fund": "基金",
	"acclist_addFund": "添加资金",
	"acclist_addFundTo": "将资金添加到",
	"acclist_tradingId": "交易编号",
	"acclist_addingFundTo": "将资金添加到",
	"acclist_tradingAcc": "",
	"acclist_fund_msz": "存款成功",
	"acclist_fund_mszErr": "存款不成功",
	"acclist_changeLeverage": "更改杠杆",
	"acclist_changePassword": "更改密码",
	"acclist_internalTransfer": "内部转账",
	"acclist_tradeNow": "立即交易",
	"acclist_detachAcc": "分离帐户",
	"accId_TransFromAccId": "从账户ID转账",
	"accId_selectAccountId": "选择帐户编号",
	"accId_fieldReq": "字段为必填项",
	"closetrad_login": "登录",
	"closetrad_order": "订单",
	"closetrad_symbol": "符号",
	"closetrad_volume": "数量",
	"closetrad_openPrice": "开盘价",
	"closetrad_openTime": "开放时间",
	"closetrad_commision": "佣金",
	"closetrad_type": "类型",
	"closetrad_SL": "止损",
	"closetrad_TP": "止盈",
	"closetrad_closePrice": "收盘价",
	"closetrad_closeTime": "关闭时间",
	"closetrad_Swap": "掉期",
	"closetrad_PNL": "盈亏",
	"closetrad_comment": "评论",
	"closetrad_price": "价格",
	"OCtradelist_balance": "余额",
	"OCtradelist_margin": "保证金",
	"OCtradelist_equity": "净值",
	"OCtradelist_pnl": "盈亏",
	"OCtradelist_tradeNow": "立即交易",
	"OCtradelist_opentrade": "建仓",
	"OCtradelist_closetrade": "平仓",
	"openOrder_orderId": "订单编号",
	"openOrder_accountId": "账户编号",
	"openOrder_quantity": "数量",
	"openOrder_triggered": "被触发",
	"openOrder_side": "边",
	"openOrder_tradeId": "交易编号",
	"openOrder_profit": "利润",
	"openOrder_agentComm": "代理佣金",
	"openOrder_cmd": "命令",
	"openOrder_sl": "止损",
	"openOrder_tp": "止盈",
	"openOrder_swaps": "互换",
	"trade_cal_title": "交易计算器",
	"trade_cal_title_Txt": "我们的在线计算器为您提供了一种简单的方法来分析您计划进行的交易。我们帮助您根据市场状况计算价值，并为您提供即时结果。",
	"trade_cal_Commission": "佣金",
	"trade_cal_Multi_Target": "多目标",
	"trade_cal_Pivot_Points": "枢轴点",
	"trade_cal_Profit_Loss": "损益",
	"trade_cal_Fibonacci": "斐波那契比率",
	"trade_cal_Pip_Value": "点值",
	"trade_cal_Swap": "掉期",
	"trade_cal_Position_Size": "仓位大小",
	"trade_cal_Currency_Convertor": "货币转换器",
	"cal_comm_title": "佣金",
	"cal_comm_title_txt": "使用我们的佣金计算器计算您将为交易支付的佣金。Fxview收取单程1/100，000美元的佣金（或往返2/100，000美元）。我们的佣金计算器将帮助您计算任何给定交易的佣金是多少。只需输入资产类别，品种，账户基础货币和交易规模，然后按\"立即计算\"。",
	"cal_comm_forex": "外汇",
	"cal_comm_commodities": "商品",
	"cal_comm_indices": "指标",
	"cal_comm_Asset_Class": "资产类别",
	"cal_comm_Field_req": "此段为必填项",
	"cal_comm_USD": "美元",
	"cal_comm_GBP": "英镑",
	"cal_comm_AUD": "澳元",
	"cal_comm_EUR": "欧元",
	"cal_comm_accBaseCurr": "账户基础货币",
	"cal_comm_Symbol": "符号",
	"cal_comm_trade_size_lot": "交易规模（手数）",
	"cal_comm_now": "立即计算",
	"cal_comm_Comm_roundT": "佣金（往返）",
	"cal_marg_title": "保证金",
	"cal_marg_title_txt": "保证金计算器可帮助您确定开仓所需的保证金。只需选择资产类别，品种，账户货币和交易规模，即可根据为不同类型的工具提供的最大杠杆来确定所需的保证金。",
	"cal_marg_Field_req": "此段为必填项",
	"cal_marg_accBaseCurr": "账户基础货币",
	"cal_marg_Symbol": "符号",
	"cal_marg_trade_size_lot": "交易规模（手数）",
	"cal_marg_now": "立即计算",
	"cal_marg_req": "保证金要求",
	"cal_marg_max_lev": "最大杠杆",
	"cal_marg_forex": "外汇",
	"cal_marg_commodities": "商品",
	"cal_marg_indices": "指标",
	"cal_milti_Target": "多目标",
	"cal_milti_Target_txt": "该计算器可帮助交易者计划在特定目标水平上应平仓的哪一部分，以获得最佳的风险回报率。",
	"cal_milti_Field_req": "此段为必填项",
	"cal_milti_accBaseCurr": "账户基础货币",
	"cal_milti_Symbol": "符号",
	"cal_milti_Position_Type": "头寸类型",
	"cal_milti_Buy": "买",
	"cal_milti_Sell": "卖",
	"cal_milti_Open_Price": "开盘价",
	"cal_milti_Stop_loss_Price": "止损价格",
	"cal_milti_trade_size_lot": "交易规模（手数）",
	"cal_milti_Target_Price": "目标价格",
	"cal_milti_lots_Clos_Target": "在目标处关闭的手数",
	"cal_milti_Net_Lot_size": "净手数：",
	"cal_milti_Now": "立即计算",
	"cal_milti_Target_Profit": "目标利润",
	"cal_milti_Total_Profit": "总利润",
	"cal_milti_Return_Risk": "回归风险",
	"cal_pivot_point_txt": "Fxview提供了一个枢轴点计算器，以帮助您确定主要趋势的方向并确定支撑位和阻力位。",
	"cal_pivot_High": "高",
	"cal_pivot_Low": "低",
	"cal_pivot_Open": "打开",
	"cal_pivot_Close": "关闭",
	"cal_pivot_Calculate_Now": "立即计算",
	"cal_pivot_Clear": "清除",
	"cal_pivot_CLASSIC": "经典",
	"cal_pivot_WOODIE": "伍迪",
	"cal_pivot_CAMARILLA": "卡马里利亚",
	"cal_pivot_DMARKS": "德马克斯",
	"cal_pivot_Resistance": "阻力",
	"cal_pivot_Pivot_Points": "枢轴点",
	"cal_pivot_Support": "支持",
	"cal_pivot_Field_req": "此段为必填项",
	"cal_pivot_PivotPoints": "枢轴点",
	"cal_profit_Loss": "损益",
	"cal_profitL_Txt": "Fxview的™损益计算器是一个基本的工具，可以帮助您计算交易的利润或损失。只需选择资产类别，品种，账户基础货币，所需的开盘价和收盘价，头寸类型和交易规模（以手为单位），然后按\"立即计算\"。",
	"cal_profitLField_req": "此段为必填项",
	"cal_profitL_accBaseCurr": "账户基础货币",
	"cal_profitL_Symbol": "符号",
	"cal_profitL_Pos_Type": "头寸类型",
	"cal_profitL_Buy": "买",
	"cal_profitL_Sell": "卖",
	"cal_profitL_Open_Price": "开盘价",
	"cal_profitL_Close_Price": "收盘价",
	"cal_profitL_trade_size_lot": "交易规模（手数）",
	"cal_profitL_Now": "立即计算",
	"cal_Fibonacci": "斐波那契",
	"cal_fibo_txt": "使用fxview的™斐波那契计算器，您可以根据上升趋势或下降趋势中图表的极值点来计算斐波那契回撤位。只需将高值和低值开始。",
	"cal_fibo_Uptrend": "趋势",
	"cal_fibo_Downtrend": "跌势",
	"cal_fibo_Field_req": "此段为必填项",
	"cal_fibo_High": "高",
	"cal_fibo_Low": "低",
	"cal_fibo_Now": "立即计算",
	"cal_fibo_Retracements": "回撤",
	"cal_fibo_Support": "支持",
	"cal_Pip_Value": "点值",
	"cal_Pip_txt": "作为管理风险策略的有效工具，我们的点值计算器可让您计算每个头寸的每点值。使用此工具，您可以更精确地监控每笔交易的风险。",
	"cal_Pip_Field_req": "此段为必填项",
	"cal_Pip_accBaseCurr": "账户基础货币",
	"cal_Pip_Symbol": "符号",
	"cal_Pip_trade_size_lot": "交易规模（手数）",
	"cal_Pip_Now": "立即计算",
	"cal_swap": "掉期",
	"cal_swap_txt": "掉期可以被认为是保持未平仓头寸的融资成本。它们可以是正面的或负面的，当头寸在一夜之间保持开放时，它们被支付/接收。它们对于多头和空头头寸是不同的，并且在不同的工具之间也有所不同。",
	"cal_swap_MT4_MT5": "MT4/MT5",
	"cal_swap_ACT": "ACT",
	"cal_swap_Field_req": "此段为必填项",
	"cal_swap_accBaseCurr": "账户基础货币",
	"cal_swap_Symbol": "符号",
	"cal_swap_Num_Days": "天数",
	"cal_swap_trade_size_lot": "交易规模（手数）",
	"cal_swap_Swap_Long": ">掉期长仓",
	"cal_swap_Swap_Short": "掉期短仓",
	"cal_Position_Size": "仓位大小",
	"cal_position_txt": "Fxview的™头寸大小计算器可以帮助您计算您可以开立多少手头寸，给定您愿意承担损失风险的预定金额。只需指定资产类别，账户基础货币，符号，头寸类型，开盘价和止损，账户余额和风险百分比（即您愿意承担损失风险的账户余额的百分比），然后按\"立即计算\"。",
	"cal_position_Field_req": "此段为必填项",
	"cal_position_accBaseCurr": "账户基础货币",
	"cal_position_Symbol": "符号",
	"cal_position_Position_Type": "头寸类型",
	"cal_position_BUY": "买",
	"cal_position_SELL": "卖",
	"cal_position_Open_Price": "开盘价",
	"cal_position_Account_Balance": "账户余额",
	"cal_position_Stop_Loss": "止损",
	"cal_position_Risk_Perc": "风险百分比",
	"cal_position_trade_size_lot": "手数交易规模",
	"cal_position_Now": "立即计算",
	"cal_curr_Convertor": "货币转换器",
	"cal_curr_conv_txt": "Fxview的™货币转换器允许用户根据当前汇率检查一种货币对另一种货币的价值。使用我们的货币转换器，您只需点击几下即可转换任何两种货币。",
	"cal_curr_conv_From": "货币从",
	"cal_curr_conv_To": "货币至",
	"cal_curr_conv_Amount": "量",
	"cal_curr_conv_Field_req": "此段为必填项",
	"cal_curr_conv_Now": "立即计算",
	"cal_curr_conv_Converted": "转换后的货币",
	"cal_leftmenu_commision": "佣金",
	"cal_leftmenu_margin": "保证金",
	"cal_leftmenu_multiTarget": "多目标",
	"cal_leftmenu_pivotpoints": "枢轴点",
	"cal_leftmenu_profitloss": "损益",
	"cal_leftmenu_fibonacci": "斐波那契",
	"cal_leftmenu_pipValue": "点值",
	"cal_leftmenu_Swap": "交换",
	"cal_leftmenu_positionSize": "仓位大小",
	"cal_leftmenu_currencyConv": "货币转换器",
	"suppIndex_requestServices": "支持",
	"suppIndex_OpenRequests": "未解决单据",
	"suppIndex_ClosedRequests": "已解决单据",
	"suppReqService_support": "支持",
	"suppReqService_howassist": "我们能为您提供什么帮助？",
	"suppReqService_emailus": "电邮我们",
	"suppReqService_email": "info@fxview.com",
	"suppReqService_liveChat": "在线聊天",
	"suppReqService_avail24": "24/5 全天候可用",
	"suppReqService_requestcallback": "请求回电",
	"suppReqService_office": "办公室： +442031505221",
	suppReqService_support_phn: 'Support: +442031505221',
	"suppReqService_createTicket": "创建客服查询单据",
	"suppReqService_helpSupport": "我们能提供什么帮助？",
	"suppReqService_back": "返回",
	"suppReqService_AddPaymentMethod": "添加付款方式",
	"ZULU": "ZULU",
	"MQL5": "断续器",
	"depositBonus": "存款奖金",
	"referfriend": "推荐朋友",
	"supp_Wallet": "钱包",
	"contactReq": "需要联系时间",
	"support_ticketNumber": "单据号码",
	"support_reason": "原因",
	"support_created": "日期",
	"support_action": "行动",
	"suppview_backToTicket": "支持主页",
	"suppview_thankyou": "感谢您验证您的身份，欢迎来到Fxview！您现在可以开立真实交易账户并开始交易。",
	"suppview_createliveAcc": "创建真实账户",
	"suppview_whilevalidate1": "在验证您的地址证明文件时，我们注意到注册时输入的地址和身份证号码与验证期间上传的文件不符。",
	"suppview_whilevalidate2": "在验证您的地址证明文件时，我们注意到注册时输入的地址与验证期间上传的文件不匹配。",
	"suppview_whilevalidate3": "在验证您的地址证明文件时，我们注意到注册时输入的身份证号码与验证期间上传的文件不符。",
	"suppview_originalAdress": "原始地址",
	"suppview_stepMsz18": "我不想改变任何事情",
	"suppview_preQues": "上一个问题",
	"suppview_nextQues": "下一个问题",
	"suppview_stepMsz21": "解决冲突",
	"suppview_idNumEnt": "输入的身份证号码",
	"suppview_percentComplete": "完成百分比",
	"suppview_nationalityEntered": "输入的国籍",
	"suppview_fillone": "请至少填写一个字段",
	"otpVerif_otpVerification": "一次性密码验证",
	"otpVerif_otpVerificationText1": "一次性 Pin 图已发送到您的电子邮件。",
	"otpVerif_resendOtpTicket": "收件箱或垃圾邮件文件夹中没有收到电子邮件？发送",
	"otpVerif_back": "返回",
	"otpVerif_backToTicket": "支持主页",
	"profileReq_getHelpWith": "获取有关的帮助",
	"profileReq_Queries": "相关查询",
	"profileReq_relatedTopics": "相关主题",
	"profileReq_inversterPass": "如果您在从MT4 / MT5平台设置投资者密码时遇到任何问题，请继续创建支持请求",
	"profileReq_notSatisfied": "我不满意",
	"profileReq_lodgeComplaint": "提交投诉",
	"profileReq_helpUsWithYour": "帮助我们解决您的问题",
	"profileReq_askOtherQuestions": "向我们询问任何其他问题",
	"profileReq_AddBankDetails": "添加银行详细信息",
	"profileReq_AddSkrillDetails": "添加 Skrill ID 详细信息",
	"profileReq_AddNetellerDetails": "添加 Neteller ID 详细信息",
	"profileReq_AddCreditCardDetails": "添加信用卡详细信息",
	"profileReq_inn": "在",
	"profileReq_emailHeading": "请在下面输入您的新电子邮件ID",
	"profileReq_exsistsEmailAddress": "现有电子邮件地址",
	"profileReq_newEmail": "输入您的新电子邮件地址",
	"profileReq_EmailfieldValid": "请输入有效的电子邮件地址",
	"profileReq_EmailfieldReq": "电子邮件字段为必填项",
	"profileReq_changeEmailAddress": "更改电子邮件地址",
	"profileReq_mobileHeading": "请在下面输入您的新手机号码",
	"profileReq_existingMobileNumber": "现有手机号码",
	"profileReq_InvalidNumber": "无效号码",
	"profileReq_changeMobileNumber": "更改手机号码",
	"profileReq_postCodeRequired": "邮政编码为必填项",
	"profileReq_residenceCountryRequired": "居住国为必填项",
	"profileReq_uploadRecentAddressProof": "上传最近的地址证明",
	"profileReq_docReq": "文件为必填项",
	"profileReq_changeAddress": "更改地址",
	"profileReq_bankName": "银行名称：",
	"profileReq_AccountName": "帐户名称",
	"profileReq_bankNameRequired": "银行名称为必填项",
	"profileReq_accountHolderRequired": "账户持有人姓名为必填项",
	"profileReq_AccNumber": "账户号码：",
	"profileReq_accountNumberRequired": "帐号为必填项",
	"profileReq_country": "国家",
	"profileReq_countryFieldRequired": "国家/地区字段为必填项",
	"profileReq_IBAN": "银行账户号码",
	"profileReq_ibanRequired": "需要 银行账户号码",
	"profileReq_MyBankNotIBAN": "我的银行不™提供账户号码",
	"profileReq_SwiftCode": "快速/BIC/排序代码",
	"profileReq_swiftCodeRequired": "快速代码是必需的",
	"profileReq_bankAdd": "银行地址：",
	"profileReq_bankAddressRequired": "银行地址为必填项",
	"profileReq_UpBankStatement": "上传银行对账单",
	"profileReq_fileallow": "只允许 jpg、jpeg、png、pdf、docx、doc、xls、xlsx 文件！",
	"profileReq_addNewBank": "添加新的银行账户",
	"profileReq_last4Digit": "最后 4 位数字是必需的，并且仅包含数字字符",
	"profileReq_first4Digit": "前 4 位数字是必需的，并且仅包含数字字符",
	"profileReq_frontBack": "我们需要以下代码进行卡验证 -",
	"profileReq_frontPhotoCredit": "卡正面彩色复印件，显示：全名，到期日期，银行名称/徽标，信用卡号的前4位和后4位数字隐藏中间的8位数字。",
	"profileReq_uploadSupportingDocument": "上传支持文档",
	"profileReq_backPhotoCredit": "隐藏CVV安全码的卡背面的彩色副本。背面副本应显示持有人的标志",
	"profileReq_submit": "提交",
	"profileReq_paymentRequiredNumeric": "付款 ID 字段是必需的，只能包含数字字符。",
	"profileReq_netSkrill1": "请上传截图",
	"profileReq_netSkrill2": "个人资料联系全名，",
	"profileReq_netSkrill3": "标识和地址。我们将匹配名称和地址",
	"profileReq_userDetails": "用户详细信息",
	"profileReq_ComplaintDetails": "投诉详情",
	"profileReq_employeeWhoOffered": "向客户提供服务的员工：",
	"profileReq_timeDisputed": "争议情况的日期和时间（以MetaTrader服务器时间计算）：",
	"profileReq_TheDisputeTime": "需要争议时间",
	"profileReq_ticNoContested": "所有有争议的仓位和/或挂单的单据号码：",
	"profileReq_DisputedAmount": "争议金额：",
	"profileReq_reportComplaint": "您是否向任何监管机构报告了您的投诉？",
	"profileReq_stateNameAuth": "请说明监管机构的名称",
	"profileReq_TheAuthorityName": "颁发机构名称为必填项",
	"profileReq_DetailedDescript": "投诉的详细说明：",
	"profileReq_attachTogetherForm": "请随本表格附上您的索赔的任何支持证据，以方便fxview调查您的投诉。支持证据可能包括与投诉相关的任何文件（屏幕截图，聊天记录，电话记录等）。",
	"profileReq_Subject": "主题",
	"profileReq_yourMsz": "您的留言",
	"profileReq_ticketHasbeenComplaint": "您的投诉已成功注册",
	"profileReq_ticketHasbeenCreated": "您的单据已创建",
	"profileReq_proMsz19": "前往单据",
	"profileReq_entervalidcard": "请输入有效的卡号",
	"profileReq_changeEmail": "请根据以下详细信息更改我<br>的电子邮件 旧电子邮件：",
	"profileReq_NEWEmail": "<br> 新电子邮件 ：",
	"profileReq_changeMobile": "请根据以下详细信息更改我的手机<br>号码 旧号码：",
	"profileReq_newNumber": "<br> 新号码 ：",
	"profileReq_changebankinfo": "请根据以下详细信息更改我的银行信息 <br> 帐号：",
	"profileReq_holdername": "<br> 持有人姓名 ：",
	"profileReq_bankname": "<br> 银行名称 ：",
	"profileReq_bankcode": "<br> 银行代码 ：",
	"profileReq_sortcode": "<br> 排序代码 ：",
	"profileReq_bankAddress": "<br> 银行地址 ：",
	"profileReq_changeadress": "请根据以下详细信息更改我的<br>地址 地址1 ：",
	"profileReq_adresstwo": "<br> 地址2 ：",
	"profileReq_postcode": "<br> 邮 编 ：",
	"profileReq_residenceCountry": "<br> 居住国 ：",
	"profileReq_nation": "<br> 国籍：",
	"profileReq_City": "<br> 城市：",
	"profileReq_pleaseAdd": "请添加",
	"profileReq_paymentmethod": "以下详细信息<br>的付款方式",
	"profileReq_number": "数：",
	"profileReq_expiryDate": "<br> 有效期：",
	"profileReq_id": "编号 ：",
	"autoscan_AutochartistScanner": "自动图表扫描仪",
	"autoscan_IBintegrateAdvancedTool": "AutoChartist是一款首屈一指的图表模式识别软件，可扫描交易工具并根据突破，回撤，支撑和阻力位自动识别交易设置，以便您再也不会错过任何机会。",
	"autoscan_closeMt4": "登录您的FXVIEW MT4账户。",
	"autoscan_DownloadRunAuto": "下载并运行自动图表扫描仪应用程序。",
	"autoscan_SelectPortfoliosTrading": "选择fxview MT4平台并继续安装。",
	"autoscan_RestartMt4Platform": "重启FXVIEW MT4平台。",
	"autoscan_autochartistdesc": "自动图表扫描仪可以在真实MT4账户上使用，最低存款金额为200美元。",
	"autoscan_DisclaimerAutoChartist": "免责声明：此页面上的帖子被视为营销传播，不包含，也不应被解释为包含投资建议或投资建议，或金融工具任何交易的要约或招揽。过往表现并不预示未来业绩。如有必要，请寻求独立建议。",
	"autochar_autocharist": "自动图表专家",
	"autochar_CreateLiveAccount": "创建真实账户",
	"autochar_Cancel": "取消",
	"subVerf_reqVerify": "请求验证",
	"subVerf_dear": "亲爱的",
	"subVerf_your": "你的",
	"subVerf_accountVerMsz1": "请求已成功处理",
	"subVerf_backSubList": "返回扫描工具",
	"subtrans_heading": "订阅事务详细信息",
	"subtrans_date": "日期（创建）",
	"subtrans_payType": "薪酬类型",
	"subtrans_planprice": "计划价格",
	"subtrans_coupon": "息票",
	"subtrans_amount": "量",
	"subtrans_noData": "无数据",
	"subtrans_backVPSlist": "返回VPS列表",
	"vpsdetail_heading": "VPS详细信息",
	"vpsdetail_IPAddress": "IP地址",
	"vpsdetail_ServerId": "服务器标识",
	"vpsdetail_HostName": "主机名",
	"vpsdetail_Disk": "磁盘",
	"vpsdetail_Cpu": "中央处理器",
	"vpsdetail_Memory": "记忆",
	"vpsdetail_State": "州",
	"vpsdetail_Created": "日期",
	"vpsdetail_action": "行动",
	"toolbox_tradeToolbox": "™交易者的工具箱",
	"toolbox_moreAboutTradeToolbox": "查找更多关于交易者™工具箱的信息",
	"toolbox_tradeToolMsz1": "使用fxview Trader的工具™箱丰富您的交易 - 一套强大的指标和应用程序，为您的交易之旅增添便利。",
	"toolbox_WhatYouGet": "您能得到什么",
	"toolbox_TraderToolboxApp": "™交易者工具箱应用",
	"toolbox_TradeTerminal": "贸易终端",
	"toolbox_MiniTerminal": "迷你终端",
	"toolbox_AlarmsManager": "警报管理器",
	"toolbox_ExcelRTD": "Excel RTD",
	"toolbox_Connect": "连接",
	"toolbox_SentimentTrader": "情绪交易者",
	"toolbox_SessionMap": "会议地图",
	"toolbox_MarketManager": "市场经理",
	"toolbox_CorrelationMatrix": "相关矩阵",
	"toolbox_CorrelationTrader": "关联交易者",
	"toolbox_TickTrader": "即时报价交易者",
	"toolbox_StealthOrder": "隐形命令",
	"toolbox_IndicatorPackage": "指标包",
	"toolbox_Minichart": "迷你图表",
	"toolbox_PivotPoints": "枢轴点",
	"toolbox_HighsLows": "高点和低点",
	"toolbox_Renkobars": "砖形图",
	"toolbox_ChartGroup": "图表组",
	"toolbox_SymbolInfo": "符号信息",
	"toolbox_Gravity": "重力",
	"toolbox_Chart_in_Chart": "图表中图表",
	"toolbox_PeriodConverter": "周期转换器",
	"toolbox_Magnifier": "放大器",
	"toolbox_OrderHistory": "订单历史",
	"toolbox_FreehandDrawing": "徒手绘图",
	"toolbox_BarChanger": "换条装置",
	"toolbox_KeltnerChannel": "凯尔特纳频道",
	"toolbox_DonchianChannel": "东川海峡",
	"toolbox_CandleCountdown": "蜡烛倒计时",
	"toolbox_LinearRegression": "线性回归",
	"toolbox_howtoinstall": "如何安装交易者的工具箱",
	"toolbox_loginFxViewmt45": "登录您的FXVIEW MT5账户",
	"toolbox_ToolboxApplication": "下载并运行MT5交易者™的工具箱应用程序",
	"toolbox_FxviewMT45installation": "选择fxview MT5平台并继续安装",
	"toolbox_allowDdlImports": "单击工具>选项>专家顾问>然后单击确定以允许 DDL 导入",
	"toolbox_RestartFxviewMT45": "重启FXVIEW MT5平台",
	"toolbox_tradeToolboxliveMinDeposit": "交易者的工具箱应用程序可以在实时MT4 / 5账户上使用，最低存款金额为500美元。",
	"toolbox_DisclaimerAutoChartist": "免责声明：此页面上的帖子被视为营销传播，不包含，也不应被解释为包含投资建议或投资建议，或金融工具任何交易的要约或招揽。过往表现并不预示未来业绩。如有必要，请寻求独立建议。",
	"subscription_Subscriptionheading": "订阅",
	"subscription_SubMsz": "采取您想要的计划，以便轻松访问我们的内容，我们希望为用户提供特殊的许可证优惠。",
	"subscription_mnth": "/月",
	"subscription_freeMin": "免费 - 最小",
	"subscription_deposit": "存款",
	"subscription_Features": "特征",
	"subscription_window": "窗",
	"subscription_Memory": "记忆",
	"subscription_ssdDisk": "固态硬盘",
	"subscription_create": "创造",
	"subticket_getSubPlan": "获取此计划的订阅",
	"subticket_applyCouponCode": "申请优惠券代码 ：",
	"subticket_TotalAmount": "总量",
	"subticket_havePromoCode": "有促销代码？",
	"subticket_deducedMonthlySubscription": "请选择交易ID，如果免费VPS不符合最低条件™，您希望从中推断每月订阅的成本。",
	"subticket_demo": "演示",
	"subticket_live": "住",
	"subticket_noteUnsubTool": "注意：只有在您点击订阅后才会扣除付款",
	"subticket_clickToAgree": "点击这里同意",
	"subticket_vpsTC": "VPS T&C.",
	"subticket_linkToSub": "请点击该链接进行订阅。",
	"subticket_subsucce": "已成功订阅。要了解更多详细信息，请单击下面的按钮",
	"subticket_AutoChartPage": "转到自动图表页面",
	"subticket_controlsignalPage": "转到\"控制信号\"页面",
	"subticket_researchReportpage": "转到研究报告页面",
	"subticket_currentNewsPage": "转到当前新闻页面",
	"subticket_economicCalPage": "转到经济日历页面",
	"subticket_vpsPage": "转到VPS页面",
	"subticket_selectPromoCode": "选择促销代码",
	"subticket_EnterCouponCode": "输入优惠券代码",
	"subticket_Apply": "应用",
	"subticket_For": "为",
	"subticket_noPromoCode": "您还没有任何促销代码！",
	"subticket_vpsSubPlan": "VPS计划订阅",
	"subticket_createVPS": "请添加资金以创建VPS",
	"subticket_goDepositPage": "前往存款页面",
	"noTradingCreateNewOne": "尚无交易账户，创建新账户",
	"faMszOtp1": "或使用也可以使用2fa OTP，但您应该首先通过单击下面给出的链接启用",
	"RESEND_EMAIL": "重新发送电子邮件",
	"TECH_ERROR": "我们面临一些问题，请一段时间后尝试",
	"VALIDATION_ERROR": "验证错误",
	"INVALID_TRADING_ACC": "无效交易账户错误",
	"INVALID_WITHDRAWAL_TRANSACTION": "无效的提款交易",
	"INVALID_OTP": "无效的 OTP",
	"FILE_UPLOAD": "只允许jpg，jpeg，png，pdf文件！",
	"OTP_EXPIRED": "一次性密码已过期",
	"OTP_IP_MISMATCH": "一次性密码不匹配",
	"LOW_BALANCE_THEN_AMOUNT": "您输入的金额高于可用的可用保证金。",
	"TICKET_EXIST": "票证已存在",
	"EMAIL_EXIST": "电子邮件已存在",
	"MOBILE_EXIST": "手机号码已存在",
	"LOW_BONUS_THEN_AMOUNT": "您填写的金额很低，那么您的奖金",
	"INVALID_ACCOUNT_TRANSACTION": "无效的账户交易",
	"INVALID_TICKET_TRANSACTION": "无效机票交易",
	"DEPOSIT_LIMIT": "存款限额",
	"AMOUNT_GREATER_THEN_ALLOWED": "您输入的金额高于允许的金额。",
	"fund_msz": "存款成功",
	"suceessMsz1": "2FA 已成功启用",
	"suceessMsz2": "2FA 已成功禁用",
	"suceessMsz3": "已在您注册的电子邮件ID上发送更改密码的链接",
	"suceessMsz4": "密码更改成功",
	"suceessMsz5": "一次性密码重新发送成功",
	"suceessMsz6": "一次性密码通过您的注册电子邮件和手机号码发送",
	"suceessMsz7": "现在您有资格开立真实账户",
	"suceessMsz8": "请在15天内上传您的文件",
	"suceessMsz9": "已成功添加名称",
	"suceessMsz10": "链接已发送您的注册电子邮件ID",
	"suceessMsz11": "计划已成功取消订阅",
	"suceessMsz12": "服务重新启动成功",
	"suceessMsz13": "服务重新启动成功",
	"suceessMsz14": "服务关闭成功",
	"suceessMsz15": "服务密码更改成功",
	"suceessMsz16": "链接已发送到您注册的电子邮件地址",
	"suceessMsz17": "存款成功",
	"suceessMsz18": "一次性密码重新发送成功",
	"suceessMsz19": "添加银行成功",
	"suceessMsz20": "工单已成功创建，请等待2-3个工作日",
	"suceessMsz21": "目前，我们只允许1，00，000，00。如果您想存入超过此金额，请联系支持人员",
	"suceessMsz22": "您不得输入大于或等于存款限额的金额 - ，因为您尚未经过验证，并且您的文件仍在验证中，因此您无法存入超过2000欧元",
	"suceessMsz23": "无效金额",
	"suceessMsz24": "您的帐户未经验证",
	"suceessMsz25": "帐户 ID 应与您选择的其他帐户 ID 不同 :",
	"suceessMsz26": "至少选择 2 个选项",
	"suceessMsz27": "新密码与确认新密码不同",
	"suceessMsz28": "您的密码必须至少包含 6 个字符，并且至少包含 1 个数字、1 个大写字符和 1 个特殊字符 （！@#$%^&*/）",
	"suceessMsz29": "",
	"errorMsz1": "不好意思！此链接已被清除。单击<路由链接：to='/忘记密码>在此处</router-link>再次重置！",
}


// WEBPACK FOOTER //
// ./src/plugins/lang/languages/zh.js